/**
 * Created by mukund on 7/14/15.
 */

"use strict";

angular
    .module("mediacloudApp")
    .controller(
        "CollectionController",
        function (
            $scope,
            $compile,
            $rootScope,
            $http,
            $location,
            $state,
            $filter,
            $window,
            $timeout,
            FileUploader,
            Principal,
            CollectionService,
            SearchService,
            AssetService,
            atmosphereService,
            Auth,
            Tenant,
            SchedulerService,
            BaseFileService
        ) {
            $scope.enableQuizzing = false;

            $http({
                method: 'GET',
                url: 'api/properties?name=ENABLE_QUIZZING'
            }).then(function successCallback(response) {
                $scope.enableQuizzing = response.data.value === "true";

                if (response.data.value === "admin") {
                    var isQuizzingAdmin = Principal.hasAnyAuthority(["ROLE_QUIZZING_ADMIN"]);
                    if (isQuizzingAdmin) {
                        $scope.enableQuizzing = true;
                    }
                }
            });
            Principal.identity().then(function (account) {
                // Determine if a user is logged in
                $scope.isAuthenticated = Principal.isAuthenticated;
                $scope.isContentManager = false;
                $scope.enableScheduler = $scope.isAuthenticated();
                $scope.enableContentManagement = false;
                $scope.targetedCollection = false;
                $scope.focusOnNextCard = false;
                localStorage.removeItem('launchToken');
                localStorage.removeItem('launchState');

                $http({
                    method: "GET",
                    url: "lti13/tokenState",
                }).then(function successCallback(response) {
                    if (response.data.token != null) {
                        localStorage.setItem("launchToken", response.data.token);
                    }
                    if (response.data.state != null) {
                        localStorage.setItem("launchState", response.data.state);
                    }
                });

                setTimeout(function(){
                    if($window.location.hash.indexOf("#/lms/playback/") !== 0) {
                        //standalone
                        if($window.location.hash.indexOf('course') > -1) {
                            $scope.rootCollectionType = {value: 'course'};
                        }

                        if($window.location.hash.indexOf('protected') > -1) {
                            $scope.rootCollectionType = {value: 'collection'};
                        }

                        if($window.location.hash.indexOf('collection') > -1) {
                            $scope.rootCollectionType = {value: 'collection'};
                        }

                        if($window.location.hash.indexOf('channel') > -1) {
                            $scope.rootCollectionType = {value: 'channel'};
                        }
                    }

                    $('.root-collection .collection-icon').removeClass('course');
                    $('.root-collection .collection-icon').removeClass('collection');
                    $('.root-collection .collection-icon').removeClass('channel');

                    var rootBCIcon = document.querySelector('.root-collection .collection-icon');
                    var iconType = $scope.rootCollectionType;
                    rootBCIcon.classList.add(iconType.value);
                }, 300)

                $http({
                    method: "GET",
                    url: "api/properties?name=ENABLE_SCHEDULER",
                }).then(function successCallback(response) {
                    if (response.data.value != null) {
                        $scope.enableScheduler =
                            response.data.value === "false" ? false : true;
                    }
                });

                $http({
                    method: "GET",
                    url: "api/properties?name=ENABLE_CONTENT_MANAGEMENT",
                }).then(function successCallback(response) {
                    if (response.data.value != null) {
                        $scope.enableContentManagement =
                            response.data.value === "false" ? false : true;
                    }
                });

                $scope.enableAddMedia = $scope.isAuthenticated();
                $http({
                    method: "GET",
                    url: "api/properties?name=FEATURE_FLAG_ENABLE_UPLOADER_FOR_INSTRUCTORS",
                }).then(function successCallback(response) {
                    if (response.data.value != null) {
                        var enableUploaderForInstructors =
                            response.data.value === "false" ? false : true;
                        if (
                            !enableUploaderForInstructors &&
                            $scope.account.authorities.indexOf("ROLE_ADMIN") ==
                                -1
                        ) {
                            $scope.enableAddMedia = false;
                        }
                    }
                });

                $http({
                    method: "GET",
                    url: "api/user/iscontentmanager",
                }).then(function successCallback(response) {
                    $scope.isContentManager = response && response.data;
                    $rootScope.isContentManager = response && response.data;
                });

                // aahmed: 06-23-2021: ENG-4000: Modified checks to see if user is in iframe and is coming in via lmsCourse state
                if (
                    $state.params.isLTI !== "1" &&
                    $rootScope.toState.name === "lmsCourse"
                ) {
                    if ($scope.isAuthenticated()) {
                        Auth.logout();
                    }

                    $rootScope.previousStateName = undefined;

                    $rootScope.previousStateParams = undefined;

                    Tenant.info().then(function (data) {
                        var managerUrl = data.managerUrl;
                        // logout of MediaManager and redirect to PPnP
                        if (managerUrl) {
                            $http.get(managerUrl + "/j_acegi_logout", {
                                withCredentials: true,
                            });
                            $window.location.href = managerUrl.substring(
                                0,
                                managerUrl.lastIndexOf("/")
                            );
                        }
                    });
                } else {
                    $scope.account = account;

                    $scope.errors = [];
                    $scope.clickUploader = function () {
                        $scope.errors = [];
                        $("#single-uploader-input").click();
                    };

                    if ($state.params.collectionId) {
                        $scope.collectionContentsPerRow = 4;
                        $scope.collectionContentsPerPage = 8;

                        $scope.submissions = { new: 0 };

                        $scope.pagination = {
                            current: 1,
                        };

                        var isAtmosphereSetup = false;
                        var defaultContentMaxHeight = 360,
                            defaultContentMinHeight = 360,
                            //360 for grid view
                            //180 for list view
                            // defaultContentMinHeight = 250 (card size before 6.12),
                            contentHeight = defaultContentMaxHeight;

                        // Sets the the default view to thumbnails (grid) for the collection content
                        $scope.activeView = "grid";

                        $scope.content = {
                            type: "",
                            items: [],
                        };

                        $scope.showFilterAndSort = false;
                        $scope.inlineFolderCreate = false;
                        $scope.showBreadcrumbEllipsis = false;

                        $scope.breadcrumb = { show: false };

                        $scope.render = false;

                        $scope.search = { query: "", activateSearch: false };

                        // Options for filtering collection contents
                        $scope.filters = [
                            { id: "fav", name: "Favorites", selected: false },
                            { id: "fol", name: "Folders", selected: false },
                            { id: "aud", name: "Audio", selected: false },
                            { id: "zip", name: "Composites", selected: false },
                            { id: "doc", name: "Documents", selected: false },
                            { id: "img", name: "Images", selected: false },
                            { id: "pod", name: "Podcasts", selected: false },
                            { id: "vid", name: "Video", selected: false },
                        ];

                        // Options for sorting collection contents
                        $scope.sorts = [
                            { id: "accesses", name: "Accesses" },
                            { id: "contributor", name: "Contributor" },
                            { id: "publishedDate", name: "Published Date" },
                            { id: "title", name: "Title" },
                        ];

                        $scope.activeSortId = "publishedDate";

                        $scope.filterAndSortText = "Filter / Sort";

                        $scope.showSearchResults = false;

                        $scope.isLMSCourse = false;

                        $scope.filterApplied = false;

                        $scope.allowScheduling = false;

                        $scope.copyOf = {
                            courseName: "",
                        };

                        // Obtain the Parent Collection Type from the URL
                        var collectionType = $state.current.name.toLowerCase();
                        if ($state.current.name === "lmsCourse") {
                            collectionType = "course";
                            $scope.isLMSCourse = true;

                            $('.single-course-wrapper').parents('html').css('overflow-x', 'hidden');
                        }

                        var logger = function (msg) {
                            var activated = false;

                            if (activated) {
                                console.log(msg);
                            }
                        };

                        var generateTreePath = function(tree) {
                            //first level folders
                            var folders = JSON.parse(JSON.stringify(tree.children));
                            var result = [];
                            var temp;
                            var child;

                            for (var i = 0; i < folders.length; i++) {
                                child = folders[i];
                                temp = folders[i].title;

                                while(child.children && child.children.length) {
                                    child = child.children;

                                    for(var j = 0; j < child.length; j++) {
                                        temp += child[j].title;
                                    }
                                }

                                result.push(temp);
                            }
                        }

                        var setSelectAllCheckboxMargin = function() {
                            var idIntervalSelectAll = setInterval(function() {
                                if($('.select-all-container').length) {
                                    clearInterval(idIntervalSelectAll);
                                    $('.select-all-container').css('margin-left', $scope.activeView === 'grid' ? '14px' : '6px');
                                }
                            }, 10);
                        }

                        // For every page reload, fetch the parent collection and its assets
                        $scope.collectionId = $state.params.collectionId;

                        $scope.quizAssetId = null;
                        $scope.quizCollectionId = null;
                        $scope.showResyncButton = false;
                        $scope.showStudentSubmissionQuizId = null;
                        if ($location.search() && $location.search().quizAssetId) {
                            $scope.quizAssetId = $location.search().quizAssetId;
                        }
                        if ($location.search() && $location.search().quizCollectionId) {
                            $scope.quizCollectionId = $location.search().quizCollectionId;
                        }
                        if ($location.search() && $location.search().showResyncButton) {
                            $scope.showResyncButton = $location.search().showResyncButton;
                        }
                        if ($location.search() && $location.search().showStudentSubmissionQuizId) {
                            $scope.showStudentSubmissionQuizId = $location.search().showStudentSubmissionQuizId;
                        }
                        if ($scope.quizAssetId && $scope.quizCollectionId) {
                            sessionStorage.setItem('isAssignmentFromLMS', true);
                            if ($scope.showStudentSubmissionQuizId) {
                                $state.go("quizzingReportStudent", {
                                    collectionId: $scope.quizCollectionId,
                                    assetId: $scope.quizAssetId,
                                    quizId: $scope.showStudentSubmissionQuizId,
                                    isPreview: false,
                                    showResyncButton: $scope.showResyncButton
                                });
                            }
                            else {
                                $state.go('quizzing', {
                                    collectionId: $scope.quizCollectionId,
                                    assetId: $scope.quizAssetId,
                                    collectionType: 'course',
                                    isNewQuiz: false,
                                    isFromPnP: false
                                });
                            }
                        }
                        else {
                            sessionStorage.setItem('isAssignmentFromLMS', false);
                        }

                        $scope.unpublished = false;

                        $scope.getParent = function (cid) {
                            logger("getParent " + cid);

                            $scope.showBreadcrumbEllipsis = false;

                            if(!cid) {
                                cid = $state.params.collectionId;
                            }

                            var rootCollectionIdPromise = new Promise(function(resolve) {
                                if($rootScope.rootCollectionId) {
                                    CollectionService.GetCollection.get(
                                        {
                                            cid: $rootScope.rootCollectionId,
                                            type: collectionType.toUpperCase(),
                                        },
                                        function (rootCollection) {
                                            $rootScope.rootLevelCollectionTitle = $scope.rootCollectionTitle = rootCollection.title;

                                            if(!$scope.rootCollectionType) {
                                                $scope.rootCollectionType = $rootScope.rootCollectionType = rootCollection.type;
                                            }

                                            $rootScope.rootCollectionId = null;
                                            resolve();
                                        });
                                } else {
                                    resolve();
                                }
                            });

                            rootCollectionIdPromise.then(function() {
                                CollectionService.GetCollection.get(
                                    {
                                        cid: cid,
                                        type: collectionType.toUpperCase(),
                                    },
                                    function (parentCollection) {
                                        // This is the top level collection
                                        $scope.parentCollection = parentCollection;
                                        $scope.currentCollectionTitle = parentCollection.title;

                                        if(!$scope.rootCollectionTitle) {
                                            $rootScope.rootLevelCollectionTitle = $scope.rootCollectionTitle = parentCollection.title;
                                        }

                                        if(!$scope.rootCollectionType) {
                                            $scope.rootCollectionType = $rootScope.rootCollectionType = parentCollection.type;
                                        }

                                        // This is the collection that the user is currently viewing (could be the top level collection or sub-collection)
                                        $scope.currentCollection = parentCollection;
                                        $scope.currentCollection.pathLength = parentCollection.path.split("/").length;

                                        // The $timeout will run after this $digest cycle completes
                                        $timeout(function () {
                                            var calculateRows = function () {
                                                var courseHeaderHeight = angular
                                                        .element(
                                                            "#collection-header"
                                                        )
                                                        .outerHeight(),
                                                    courseNavHeight = angular
                                                        .element("#pnp-nav")
                                                        .outerHeight(),
                                                    controlPanelHeight = angular
                                                        .element("#control-panel")
                                                        .outerHeight(),
                                                    courseFooterHeight = angular
                                                        .element(
                                                            "#collection-footer"
                                                        )
                                                        .outerHeight(),
                                                    courseContainerHeight =
                                                        $window.innerHeight,
                                                    availableassetspace =
                                                        courseContainerHeight -
                                                        (courseHeaderHeight +
                                                            courseNavHeight +
                                                            controlPanelHeight +
                                                            courseFooterHeight);
                                                // rowsToShow = Math.floor(availableassetspace / defaultContentMinHeight),
                                                var rowsToShow;
                                                var contentHeightCalculated =
                                                    availableassetspace /
                                                        rowsToShow -
                                                    20;

                                                contentHeight =
                                                    contentHeightCalculated >
                                                    defaultContentMaxHeight
                                                        ? defaultContentMaxHeight
                                                        : contentHeightCalculated;

                                                //Forcing to always show 2 lines.
                                                //It works even if there are less than 4 items.
                                                rowsToShow = 2;
                                                $scope.rowsToShow = rowsToShow;

                                                var currentAssetCount =
                                                    ($scope.pagination.current -
                                                        1) *
                                                        $scope.collectionContentsPerPage +
                                                    1;
                                                var newContentsPerPage =
                                                    $scope.collectionContentsPerRow *
                                                    rowsToShow;

                                                // Only fetch assets from the server if necessary
                                                if (
                                                    newContentsPerPage !==
                                                        $scope.collectionContentsPerPage ||
                                                    !$scope.currentCollection
                                                        .contents
                                                ) {
                                                    $scope.collectionContentsPerPage =
                                                        newContentsPerPage;
                                                    var pageToView = Math.ceil(
                                                        currentAssetCount /
                                                            $scope.collectionContentsPerPage
                                                    );
                                                    $scope.pagination.current =
                                                        pageToView;
                                                    getCollectionContent(
                                                        pageToView
                                                    );
                                                } else {
                                                    makeContentResponsive(null);
                                                }
                                            };

                                            // Calculate how many rows to show within the PnP LMS iframe
                                            if ($scope.isLMSCourse) {
                                                calculateRows();
                                                // Run the calculations when the iframe resizes
                                                var windowWidth = $(window).width();
                                                angular
                                                    .element($window)
                                                    .on("resize", function () {
                                                        if (
                                                            $(window).width() !==
                                                            windowWidth
                                                        ) {
                                                            if (
                                                                $scope.activeLink ===
                                                                    "pnp" &&
                                                                $scope.activeView ===
                                                                    "grid"
                                                            ) {
                                                                calculateRows();
                                                            }
                                                        }
                                                    });
                                            }
                                            if ($state.params.showUnpublished) {
                                                $state.params.showUnpublished = null;
                                                $('.unpublished-tab').click();
                                            }
                                        });

                                        // Get the featured asset
                                        if (
                                            $scope.parentCollection.featuredAssetId
                                        ) {
                                            CollectionService.GetFeaturedAsset.get(
                                                { cid: cid },
                                                function (featuredAsset) {
                                                    $scope.currentCollection.featuredAsset =
                                                        featuredAsset;
                                                }
                                            );
                                        }

                                        $scope.rootLevelCollection = $scope.currentCollection;

                                        //If the fetched collection is not the root collection,
                                        //the root collection needs to be used for the breadcrumb
                                        if (cid !== $state.params.collectionId) {
                                            CollectionService.GetCollection.get(
                                                {
                                                    cid: $state.params.collectionId,
                                                    type: collectionType.toUpperCase(),
                                                },
                                                function (collection) {
                                                    $scope.rootLevelCollection = collection;

                                                    //Why set the parentCollection.cid here?
                                                    // var arrPath = $scope.currentCollection.path.split("/");
                                                    // $scope.parentCollection.cid = arrPath[arrPath.length - 1];

                                                    CollectionService.GetCollectionTree.get({cid: $scope.rootLevelCollection.cid}, function (tree) {
                                                            generateTreePath(tree);
                                                            $scope.collectionTree = tree;
                                                            $scope.filteredCollectionTree = tree;
                                                            $scope.collectionTree.show = false;

                                                            if(!$scope.currentCollection.crumbs) {
                                                                $scope.currentCollection.crumbs = generateCrumbs(
                                                                    $scope.currentCollection.cid,
                                                                    $scope.currentCollection.path
                                                                );
                                                                //Get only the last 3 crumbs
                                                                if($scope.currentCollection.crumbs.length > 3) {
                                                                    $scope.crumbsForMenu = JSON.parse(JSON.stringify($scope.currentCollection.crumbs.slice(0, $scope.currentCollection.crumbs.length - 3)));
                                                                    $scope.currentCollection.crumbs = $scope.currentCollection.crumbs.slice($scope.currentCollection.crumbs.length - 3);

                                                                    $timeout(() => {
                                                                        $scope.showBreadcrumbEllipsis = false;
                                                                        $scope.$apply();
                                                                        $scope.showBreadcrumbEllipsis = true;
                                                                        $scope.$apply();
                                                                    });
                                                                } else {
                                                                    $scope.showBreadcrumbEllipsis = false;
                                                                }
                                                                manageBreadcrumbTruncation();
                                                            }
                                                        }
                                                    );
                                                }
                                            );
                                        } else {
                                            //Generate the breadcrumb
                                            CollectionService.GetCollectionTree.get(
                                                { cid: $state.params.collectionId },
                                                function (tree) {
                                                    generateTreePath(tree);
                                                    $scope.collectionTree = tree;
                                                    $scope.filteredCollectionTree = tree;
                                                    $scope.collectionTree.show = false;
                                                    $scope.currentCollection.crumbs = generateCrumbs(
                                                        $scope.currentCollection.cid,
                                                        $scope.rootLevelCollection.path
                                                    );
                                                    //Get only the last 3 crumbs
                                                    if($scope.currentCollection.crumbs.length > 3) {
                                                        $scope.crumbsForMenu = JSON.parse(JSON.stringify($scope.currentCollection.crumbs.slice(0, $scope.currentCollection.crumbs.length - 3)));
                                                        $scope.currentCollection.crumbs = $scope.currentCollection.crumbs.slice($scope.currentCollection.crumbs.length - 3);

                                                        $timeout(() => {
                                                            $scope.showBreadcrumbEllipsis = false;
                                                            $scope.$apply();
                                                            $scope.showBreadcrumbEllipsis = true;
                                                            $scope.$apply();
                                                        });
                                                    } else {
                                                        $scope.showBreadcrumbEllipsis = false;
                                                    }
                                                    manageBreadcrumbTruncation();
                                                }
                                            );
                                        }

                                        // manageBreadcrumbTruncation();

                                        $scope.pagination.current = 1;
                                        // Only fetch content here if the user is viewing the course in the standalone app.
                                        if (!$scope.isLMSCourse) {
                                            getCollectionContent(1);
                                        }

                                        if (
                                            parentCollection.type === "course" &&
                                            parentCollection.acl.indexOf("W") !== -1
                                        ) {
                                            CollectionService.GetNewMediaInboxSubmissions.get({ cid: cid }, function (response) {
                                                $scope.submissions.new =
                                                    response.newSubmissions;
                                            }
                                            );
                                            if (!isAtmosphereSetup) {
                                                atmosphereSetup();
                                            }
                                        }

                                        if (collectionType) {
                                            SchedulerService.checkAvailability.get(
                                                {
                                                    baseCollectionId:
                                                        parentCollection.cid,
                                                },
                                                function (response) {
                                                    $scope.allowScheduling =
                                                        response.result;

                                                    SchedulerService.getEventCountForCollection.get(
                                                        {
                                                            baseCollectionId:
                                                                parentCollection.cid,
                                                        },
                                                        function (response) {
                                                            $scope.hasEvents =
                                                                response.count &&
                                                                response.count > 0;
                                                        }
                                                    );
                                                }
                                            );
                                        }
                                    }
                                );
                            });

                        };

                        var destinationFolderId = $state.params.destinationFolderId;
                        var showUnpublished = $state.params.showUnpublished;
                        $state.params.destinationFolderId = null;

                        setSelectAllCheckboxMargin();

                        if (destinationFolderId) {
                            $scope.targetedCollection = true;
                            $rootScope.rootCollectionId = $state.params.collectionId;
                            $scope.getParent(destinationFolderId);
                        } else {
                            $scope.targetedCollection = false;
                            $rootScope.rootCollectionId = $state.params.collectionId;
                            $scope.getParent($state.params.collectionId);
                        }

                        $scope.cardBgColorOnFocus = "#F0F8FF";


                        var generateCrumbs = function (cid, path) {
                            logger("generateCrumbs");

                            var crumbs = [];
                            if (path) {
                                var parents = path.split("/").slice(3);
                                if (parents.length && $scope.collectionTree) {
                                    angular.forEach(
                                        $scope.collectionTree.children,
                                        function (node) {
                                            getCrumbs(node, crumbs, cid, parents);
                                        }
                                    );
                                }
                            }

                            return crumbs;
                        };

                        // recursive function that gets all parent nodes of a collection from the collection tree
                        var getCrumbs = function (node, crumbs, cid, parents) {
                            logger("getCrumbs");
                            if (node.cid && parents.indexOf(node.cid) !== -1) {
                                crumbs.push({
                                    title: node.title,
                                    cid: node.cid,
                                });
                            }
                            angular.forEach(node.children, function (child) {
                                getCrumbs(child, crumbs, cid, parents);
                            });
                        };

                        // This is run whenever the user navigates within a collection
                        $scope.openContent = function (content) {
                            logger("openContent");

                            if (content.type === "Collection") {
                                $scope.showCollectionTree = false;
                                $scope.resetFilterAndSort();
                                CollectionService.GetCollection.get(
                                    {
                                        cid: content.xid,
                                        type: collectionType.toUpperCase(),
                                    },
                                    function (collection) {
                                        $scope.currentCollection = collection;
                                        $scope.currentCollection.pathLength = collection.path.split("/").length;
                                        $scope.currentCollectionTitle = collection.title;

                                        $scope.currentCollection.crumbs = generateCrumbs(
                                            collection.cid,
                                            collection.path
                                        );

                                        setTimeout(function(){
                                            $scope.$apply();
                                        }, 0)

                                        //Get only the last 3 crumbs
                                        if($scope.currentCollection.crumbs.length > 3) {
                                            $scope.crumbsForMenu = JSON.parse(JSON.stringify($scope.currentCollection.crumbs.slice(0, $scope.currentCollection.crumbs.length - 3)));
                                            $scope.currentCollection.crumbs = $scope.currentCollection.crumbs.slice($scope.currentCollection.crumbs.length - 3);

                                            $timeout(() => {
                                                $scope.showBreadcrumbEllipsis = false;
                                                $scope.$apply();
                                                $scope.showBreadcrumbEllipsis = true;
                                                $scope.$apply();
                                            });
                                        } else {
                                            $scope.showBreadcrumbEllipsis = false;
                                        }

                                        manageBreadcrumbTruncation();

                                        $scope.pagination.current = 1;
                                        getCollectionContent(1);

                                        if (!collection.contents) {
                                            $(".row.list-group").css("height", "");
                                            $(".row.list-group").css("min-height", "");
                                            $(".row.list-group").css("max-height", "");
                                        }
                                    }
                                );
                            }
                            else if (content.type.toLowerCase() == 'quiz') {
                                AssetService.IsQuizLocked.get({
                                    cid: content.parent.cid,
                                    aid: content.xid
                                }, function(quiz) {
                                    if (quiz.isLocked) {
                                        $('#quiz-locked-modal').modal('show');
                                    }
                                    else {
                                        $state.go('quizzing', {
                                            collectionId: content.parent.cid,
                                            assetId: content.xid,
                                            collectionType: collectionType,
                                            isNewQuiz: false,
                                            isFromPnP: true
                                        });
                                    }
                                });
                            }
                            else {
                                if ($state.current.name === "lmsCourse") {
                                    $state.go("lmsPlayback", {
                                        collectionType: collectionType,
                                        collectionId: content.parent.cid,
                                        assetId: content.xid,
                                        rootCollectionId: $rootScope.rootLevelCid
                                    });
                                } else {
                                    var params = {
                                        collectionType: collectionType,
                                        collectionId: content.parent.cid,
                                        // rootCollectionId: $('#parent-collection-title-breadcrumb').attr('data-rootCollectionId'),
                                        rootCollectionId: $rootScope.rootLevelCid,
                                        assetId: content.xid,
                                        path: content.parent.path
                                        // rootPath: rootPath,
                                        // content: angular.toJson(content),
                                    };

                                    $state.go("playback", params);
                                }
                            }
                        };

                        var manageBreadcrumbTruncation = function() {
                            var tries = 0;
                            var intervalId = setInterval(function() {
                                tries++;

                                if($('.breadcrumb .sub-folder .name').height() || $('.breadcrumb .current-folder .name').height() || tries > 100) {
                                    clearInterval(intervalId);

                                    var isBreadcrumbBigger =
                                        ($('.breadcrumb .sub-folder .name').length > 0 && $('.breadcrumb .sub-folder .name')[0].offsetHeight > 28) ||
                                        ($('.breadcrumb .sub-folder .name').length > 1 && $('.breadcrumb .sub-folder .name')[1].offsetHeight > 28) ||
                                        ($('.breadcrumb .sub-folder .name').length > 2 && $('.breadcrumb .sub-folder .name')[2].offsetHeight > 28) ||
                                        ($('.breadcrumb .current-folder .name').length > 0 && $('.breadcrumb .current-folder .name')[0].offsetHeight > 28);


                                    console.log('isBreadcrumbBigger', isBreadcrumbBigger)

                                    if(isBreadcrumbBigger) {
                                        //If each subfolder is bigger than the limit

                                        //Add ellipsis to subfolders that are wider than the limit
                                        $('.breadcrumb .sub-folder .name').addClass('truncate-ellipsis');
                                        $('.breadcrumb .sub-folder .name').addClass('limit-folder-size');
                                        $('.breadcrumb .current-folder .name').addClass('truncate-ellipsis');
                                        $('.breadcrumb .current-folder .name').addClass('limit-folder-size');
                                    }

                                    setTimeout(function(){
                                        $scope.showSubFolderTooltip = [];

                                        if($('.breadcrumb .sub-folder').length > 0) {
                                            $scope.showSubFolderTooltip[0] = hasEllipsisWidth( $('.breadcrumb .sub-folder .name')[0] );
                                        }

                                        if($('.breadcrumb .sub-folder').length > 1) {
                                            $scope.showSubFolderTooltip[1] = hasEllipsisWidth( $('.breadcrumb .sub-folder .name')[1] );
                                        }

                                        if($('.breadcrumb .sub-folder').length > 2) {
                                            $scope.showSubFolderTooltip[2] = hasEllipsisWidth( $('.breadcrumb .sub-folder .name')[2] );
                                        }

                                        if($('.breadcrumb .current-folder').length) {
                                            $scope.showCurrentFolderTooltip = hasEllipsisWidth( $('.breadcrumb .current-folder .name')[0] );
                                        }

                                        $('.breadcrumb').css('opacity', 1);
                                    }, 500)
                                }



                            }, 100)
                        }

                        var hasEllipsisHeight = function(el) {
                            if(el.offsetHeight && el.scrollHeight) {
                                return el.offsetHeight < el.scrollHeight;
                            }

                            return null;
                        }

                        var hasEllipsisWidth = function(el) {
                            if(el.offsetWidth && el.scrollWidth) {
                                return el.offsetWidth < el.scrollWidth;
                            }

                            return null;
                        }

                        // This is used to fetch all content inside a collection - assets and sub-collections
                        var getCollectionContent =
                            ($scope.getCollectionContent = function (page) {
                                logger("getCollectionContent");
                                $timeout(function() {
                                    CollectionService.GetCollectionContent.get(
                                        {
                                            cid: $scope.currentCollection.cid,
                                            offset:
                                                (page - 1) *
                                                $scope.collectionContentsPerPage,
                                            limit: $scope.collectionContentsPerPage,
                                            fav: $filter("filter")(
                                                $scope.filters,
                                                { id: "fav" },
                                                true
                                            )[0].selected,
                                            fol: $filter("filter")(
                                                $scope.filters,
                                                { id: "fol" },
                                                true
                                            )[0].selected,
                                            pod: $filter("filter")(
                                                $scope.filters,
                                                { id: "pod" },
                                                true
                                            )[0].selected,
                                            aud: $filter("filter")(
                                                $scope.filters,
                                                { id: "aud" },
                                                true
                                            )[0].selected,
                                            vid: $filter("filter")(
                                                $scope.filters,
                                                { id: "vid" },
                                                true
                                            )[0].selected,
                                            img: $filter("filter")(
                                                $scope.filters,
                                                { id: "img" },
                                                true
                                            )[0].selected,
                                            doc: $filter("filter")(
                                                $scope.filters,
                                                { id: "doc" },
                                                true
                                            )[0].selected,
                                            zip: $filter("filter")(
                                                $scope.filters,
                                                { id: "zip" },
                                                true
                                            )[0].selected,
                                            sortOn: $scope.activeSortId,
                                            isActive: !$scope.unpublished
                                        },
                                        function (collectionContentList) {
                                            $scope.allItemsCollection =
                                                collectionContentList.contents;

                                            if (
                                                collectionContentList.totalContents ===
                                                0
                                            ) {
                                                $(
                                                    $(
                                                        "#selectAllCheck"
                                                    ).children()[0]
                                                ).attr("disabled", true);
                                                $("#selectAllCheck").css(
                                                    "cursor",
                                                    "not-allowed"
                                                );
                                                makeContentResponsive(null);
                                            } else {
                                                $(
                                                    $(
                                                        "#selectAllCheck"
                                                    ).children()[0]
                                                ).removeAttr("disabled");
                                                $("#selectAllCheck").css(
                                                    "cursor",
                                                    "pointer"
                                                );
                                            }

                                            //uncheck all checkboxes
                                            $("input.item-checkbox").attr(
                                                "checked",
                                                false
                                            );
                                            $("#selectAllCheck input").attr(
                                                "checked",
                                                false
                                            );

                                            $("#inlineFolderCreate").hide();
                                            $scope.currentCollection.contents = collectionContentList.contents;
                                            $scope.currentCollection.totalContents = collectionContentList.totalContents;
                                            $scope.showSearchResults = false;

                                            //If not UMD
                                            if($scope.enableContentManagement) {
                                                $scope.canEdit =  $scope.parentCollection.acl.indexOf("W") !== -1
                                            } else {
                                                //UMD
                                                $scope.canEdit =
                                                    $scope.parentCollection.acl.indexOf(
                                                        "W"
                                                    ) !== -1 && $scope.isContentManager;
                                            }

                                            console.log('$scope.enableContentManagement', $scope.enableContentManagement)
                                            console.log('$scope.isContentManager', $scope.isContentManager)


                                            if (
                                                $scope.parentCollection.acl.indexOf(
                                                    "W"
                                                ) !== -1 &&
                                                $scope.currentCollection
                                                    .totalContents === 0 &&
                                                !$scope.filterApplied &&
                                                $scope.parentCollection.cid ===
                                                    $scope.currentCollection.cid &&
                                                collectionType === "course"
                                            ) {
                                                CollectionService.getCollections({
                                                    type: "COURSE",
                                                    paginated: true,
                                                    limit: 10,
                                                    offset: 0,
                                                    rw: true,
                                                }).then(function (response) {
                                                    if (
                                                        response.collections &&
                                                        response.collections
                                                            .length > 0
                                                    ) {
                                                        var filteredCourses =
                                                            $filter("filter")(
                                                                response.collections,
                                                                {
                                                                    cid:
                                                                        "!" +
                                                                        $scope
                                                                            .parentCollection
                                                                            .cid,
                                                                },
                                                                true
                                                            );
                                                        if (
                                                            filteredCourses.length && !$scope.targetedCollection
                                                        ) {
                                                            if (!$scope.unpublished) {
                                                                $scope.copyWizardAvailable = true;
                                                                $scope.loadComponent(
                                                                    "copywizard"
                                                                );
                                                            }
                                                            else {
                                                                $scope.loadComponent("pnp");
                                                            }
                                                            $scope.oldCourses =
                                                                response;
                                                        } else {
                                                            $scope.loadComponent(
                                                                "pnp"
                                                            );
                                                            makeContentResponsive(
                                                                null
                                                            );
                                                        }
                                                    }
                                                    showCourseDescriptionEllipsis();
                                                });
                                            } else {
                                                if (collectionType === "course") {
                                                    if ($scope.copyOf.courseName) {
                                                        $scope.copyWizardAvailable = false;
                                                        // Only show the alert if the user is on the parent collection (and not a subcollection)
                                                        $scope.showCourseCopyAlert =
                                                            $scope.parentCollection
                                                                .cid ===
                                                            $scope.currentCollection
                                                                .cid;
                                                        $timeout(function () {
                                                            $scope.showCourseCopyAlert = false;
                                                            $scope.copyOf.courseName =
                                                                "";
                                                        }, 10000);
                                                    }
                                                }
                                                if($scope.unpublished){
                                                    $scope.loadComponent("unpublished");
                                                }else{
                                                    $scope.loadComponent("pnp");
                                                }

                                                //wait until there's content
                                                var timeoutId = setInterval(
                                                    function () {
                                                        if (
                                                            $(".asset-card").length
                                                        ) {
                                                            if (!contentLoaded) {
                                                                contentLoaded = true;
                                                            }
                                                            makeContentResponsive(
                                                                "getCollectionContent"
                                                            );
                                                            clearInterval(
                                                                timeoutId
                                                            );
                                                        }

                                                        setCheckAllCheckboxState();
                                                        $scope.manageCheckAllState();
                                                    },
                                                    100
                                                );

                                                showCourseDescriptionEllipsis();
                                            }
                                            $("#selectAllCheck input").prop(
                                                "checked",
                                                false
                                            );
                                            if($scope.focusOnNextCard){
                                                $scope.focusOnNextCard = false;
                                                $timeout(function(){
                                                    var cardList = $("#inlineFolderCreate").parent().find(".asset-card:not(.create-folder)");
                                                    var card = 0;
                                                    if(cardList.length > 1){
                                                        card = 1;
                                                    }
                                                    if ($scope.activeView === "grid") {
                                                        cardList.eq(card).find('.overlayimage[tabindex="0"]').focus();
                                                    }else{
                                                        cardList.eq(card).find('.card-checkbox[tabindex="0"]').focus();
                                                    }
                                                },200);
                                            }
                                        }
                                    );
                                }, 500);

                            });

                        var contentLoaded = false;

                        var setCheckAllCheckboxState = function () {
                            var items = $(".pnp-item:not(#inlineFolderCreate)");

                            if ($("#selectAllCheck").length) {
                                var checkAllCheckbox = $(
                                    "#selectAllCheck"
                                )[0];

                                if (items.length === 0) {
                                    $(checkAllCheckbox).attr("aria-disabled",true);
                                } else {
                                    $(checkAllCheckbox).attr("aria-disabled",false);
                                }
                            }
                        };

                        $scope.disableButton = function () {
                            logger("disableButton");
                            return $(".item-checkbox:checked").length === 0;
                        };

                        var makeContentResponsive = function (caller) {
                            logger("makeContentResponsive");

                            $timeout(function () {
                                setContentWidthForList();
                                setContentWidthForNewFolder();
                                alignOverflowMenu();
                            }, 1000);

                            if ($scope.isLMSCourse) {
                                $timeout(function () {
                                    if ($scope.activeView === "list") {
                                        if (
                                            $scope.currentCollection &&
                                            $scope.currentCollection.contents
                                        ) {
                                            for (
                                                var i = 0;
                                                i <
                                                $scope.currentCollection
                                                    .contents.length;
                                                i++
                                            ) {
                                                if (
                                                    $scope.currentCollection
                                                        .contents[i].type !==
                                                    "Collection"
                                                ) {
                                                    $(
                                                        $(
                                                            ".pnp-item.list-group-item"
                                                        )[i + 1]
                                                    ).height(194);
                                                } else {
                                                    $(
                                                        $(
                                                            ".pnp-item.list-group-item"
                                                        )[i + 1]
                                                    ).height(172);
                                                }
                                            }
                                        }

                                        $(
                                            ".pnp.container.cardcontainer"
                                        ).height("");
                                        $("#collection-footer").css(
                                            "margin-top",
                                            ""
                                        );
                                        $("#collection-footer").css(
                                            "height",
                                            ""
                                        );
                                        $(".row.list-group").css("height", "");
                                        $(".row.list-group").css(
                                            "min-height",
                                            ""
                                        );
                                        $(".row.list-group").css(
                                            "max-height",
                                            ""
                                        );
                                    } else if ($scope.activeView === "grid") {
                                        $('.item.pnp-item').height('unset !important');

                                        if (
                                            $scope.currentCollection &&
                                            $scope.currentCollection.contents &&
                                            $scope.currentCollection.contents
                                                .length === 0
                                        ) {
                                            $(
                                                ".pnp.container.cardcontainer"
                                            ).css(
                                                "justify-content",
                                                "flex-start"
                                            );
                                        } else {
                                            $(
                                                ".pnp.container.cardcontainer"
                                            ).css(
                                                "justify-content",
                                                "space-between"
                                            );
                                        }

                                        calculateAssetsHeight();
                                        // calculateSpaceBetweenItems(caller);
                                    }
                                }, 0);

                                if ($scope.activeView === "list") {
                                    $(".single-course-wrapper").height("");
                                }
                            }
                        };

                        var calculateAssetsHeight = function () {
                            $(".assets").css("opacity", 1);
                            $(".single-course-wrapper").height("100%");
                            $(".cardcontainer").height("100%");

                            if(!$scope.isLMSCourse) {
                                $(".assets").height("100%");
                            }
                        };

                        var calculatedItemsDistance;

                        //Determines if it is the first time we call calculateSpaceBetweenItems (CSBI)
                        $scope.isFirstCSBICall = true;
                        $scope.isSmallScreen = null;
                        $scope.isBigScreen = null;
                        var calculateSpaceBetweenItems = function (caller) {
                            logger("calculateSpaceBetweenItems");

                            if (
                                !$scope.isFirstCSBICall ||
                                caller === "getCollectionContent"
                            ) {
                                //1 - set correct CSS format
                                if (
                                    $scope.currentCollection &&
                                    $scope.currentCollection.contents &&
                                    $scope.currentCollection.contents.length > 8
                                ) {
                                    $(".pnp.container.cardcontainer").css(
                                        "justify-content",
                                        "space-between"
                                    );
                                } else {
                                    $(".pnp.container.cardcontainer").css(
                                        "justify-content",
                                        "flex-start"
                                    );
                                }

                                //2 - set height according to screen size
                                //wait until we have assets
                                if (caller === "changeView") {
                                    $(".assets").show();
                                }
                                var intervalAssets = setInterval(function () {
                                    if ($(".assets").is(":visible")) {
                                        clearInterval(intervalAssets);

                                        //all assets are visible
                                        //check if, assets count fit in container's height
                                        //if big screen, 100vh
                                        if (
                                            $(".content-wrapper").height() >
                                            $(".single-course-wrapper").height()
                                        ) {
                                            if ($scope.isBigScreen === null) {
                                                $scope.isBigScreen = true;
                                            }

                                            $(".single-course-wrapper").css(
                                                "height",
                                                "100vh"
                                            );
                                        } else if (
                                            $(".content-wrapper").height() <
                                            $(".single-course-wrapper").height()
                                        ) {
                                            if ($scope.isSmallScreen === null) {
                                                $scope.isSmallScreen = true;
                                            }
                                            //if small screen, no height
                                            $(".single-course-wrapper").css(
                                                "height",
                                                ""
                                            );
                                        } else if (
                                            $(".content-wrapper").height() ===
                                            $(".single-course-wrapper").height()
                                        ) {
                                            //if already executed
                                            //for small screen, coming back from empty folder
                                            if ($scope.isSmallScreen) {
                                                $(".single-course-wrapper").css(
                                                    "height",
                                                    ""
                                                );
                                            }
                                        }

                                        //4 - Get the distance between items given by flexbox
                                        var itemsDistance = 24;
                                        var intervalDistance = setInterval(
                                            function () {
                                                if (
                                                    caller ===
                                                    "getCollectionContent"
                                                ) {
                                                    //there's assets
                                                    $(".assets").show();
                                                    if (
                                                        $(".assets").offset()
                                                            .top > 0
                                                    ) {
                                                        itemsDistance =
                                                            $(
                                                                ".assets"
                                                            ).offset().top -
                                                            $(
                                                                ".button-container"
                                                            ).offset().top;
                                                    }
                                                    calculatedItemsDistance =
                                                        itemsDistance;
                                                }

                                                if (calculatedItemsDistance) {
                                                    itemsDistance =
                                                        calculatedItemsDistance;
                                                }

                                                if (
                                                    $(
                                                        ".button-container"
                                                    ).offset().top > 0
                                                ) {
                                                    clearInterval(
                                                        intervalDistance
                                                    );

                                                    //5 - Calculate the distance between cards
                                                    var cardsDistance = 20; //default margin
                                                    cardsDistance -=
                                                        (cardsDistance -
                                                            itemsDistance) /
                                                        2;

                                                    var intervalId =
                                                        setInterval(
                                                            function () {
                                                                if (
                                                                    $scope.currentCollection &&
                                                                    $scope
                                                                        .currentCollection
                                                                        .contents &&
                                                                    $scope
                                                                        .currentCollection
                                                                        .contents
                                                                        .length >
                                                                        4
                                                                ) {
                                                                    if (
                                                                        $(
                                                                            $(
                                                                                ".asset-card:not(.create-folder)"
                                                                            )[4]
                                                                        ).offset()
                                                                    ) {
                                                                        if (
                                                                            $scope
                                                                                .currentCollection
                                                                                .contents
                                                                                .length >
                                                                            8
                                                                        ) {
                                                                            var containerHeight =
                                                                                3 *
                                                                                (cardsDistance +
                                                                                    360);
                                                                            $(
                                                                                ".row.list-group.assets"
                                                                            ).css(
                                                                                "height",
                                                                                containerHeight
                                                                            );
                                                                        } else if (
                                                                            $scope
                                                                                .currentCollection
                                                                                .contents
                                                                                .length >
                                                                            4
                                                                        ) {
                                                                            //As sometimes cardsDistance is NaN, and it runs twice,
                                                                            // we only change height if cardsDistance is set.
                                                                            if (
                                                                                !isNaN(
                                                                                    cardsDistance
                                                                                )
                                                                            ) {
                                                                                var containerHeight =
                                                                                    2 *
                                                                                    (cardsDistance +
                                                                                        360);
                                                                                $(
                                                                                    ".row.list-group.assets"
                                                                                ).css(
                                                                                    "height",
                                                                                    containerHeight
                                                                                );
                                                                            }
                                                                        }

                                                                        clearInterval(
                                                                            intervalId
                                                                        );

                                                                        if (
                                                                            $(
                                                                                "#inlineFolderCreate"
                                                                            ).is(
                                                                                ":visible"
                                                                            )
                                                                        ) {
                                                                            if (
                                                                                $scope.rowsToShow ===
                                                                                    3 &&
                                                                                $(
                                                                                    ".item.pnp-item"
                                                                                )
                                                                                    .length >
                                                                                    12
                                                                            ) {
                                                                                $(
                                                                                    ".item.pnp-item"
                                                                                )
                                                                                    .last()
                                                                                    .hide();
                                                                            } else if (
                                                                                $scope.rowsToShow ===
                                                                                    2 &&
                                                                                $(
                                                                                    ".item.pnp-item"
                                                                                )
                                                                                    .length >
                                                                                    8
                                                                            ) {
                                                                                $(
                                                                                    ".item.pnp-item"
                                                                                )
                                                                                    .last()
                                                                                    .hide();
                                                                            } else if (
                                                                                $scope.rowsToShow ===
                                                                                    1 &&
                                                                                $(
                                                                                    ".item.pnp-item"
                                                                                )
                                                                                    .length >
                                                                                    4
                                                                            ) {
                                                                                $(
                                                                                    ".item.pnp-item"
                                                                                )
                                                                                    .last()
                                                                                    .hide();
                                                                            }
                                                                        }

                                                                        $(
                                                                            ".assets"
                                                                        ).css(
                                                                            "opacity",
                                                                            "1"
                                                                        );
                                                                    }
                                                                } else if (
                                                                    $scope.currentCollection &&
                                                                    $scope
                                                                        .currentCollection
                                                                        .contents &&
                                                                    $scope
                                                                        .currentCollection
                                                                        .contents
                                                                        .length <=
                                                                        4
                                                                ) {
                                                                    clearInterval(
                                                                        intervalId
                                                                    );
                                                                    var containerHeight =
                                                                        cardsDistance +
                                                                        360;
                                                                    $(
                                                                        ".row.list-group.assets"
                                                                    ).css(
                                                                        "height",
                                                                        containerHeight
                                                                    );
                                                                    $(
                                                                        ".assets"
                                                                    ).css(
                                                                        "opacity",
                                                                        "1"
                                                                    );
                                                                }

                                                                $(
                                                                    ".list-group.assets"
                                                                ).show();
                                                                $scope.isFirstCSBICall = false;
                                                            },
                                                            100
                                                        );
                                                }
                                            },
                                            50
                                        );
                                    }
                                }, 100);

                                //3 - wait until we have items in collection
                                var intervalCollection = setInterval(
                                    function () {
                                        if (
                                            $scope.currentCollection &&
                                            $scope.currentCollection.contents
                                        ) {
                                            if ($(".emptyfolder").length) {
                                                $(".row.list-group.assets").css(
                                                    "height",
                                                    ""
                                                );
                                                $(".row.list-group.assets").css(
                                                    "min-height",
                                                    ""
                                                );
                                                $(".row.list-group.assets").css(
                                                    "max-height",
                                                    ""
                                                );

                                                return;
                                            }

                                            clearInterval(intervalCollection);
                                        }
                                    },
                                    100
                                );
                            }
                        };

                        var alignOverflowMenu = function () {
                            logger("alignOverflowMenu");
                            var itemsCount =
                                $scope.currentCollection &&
                                $scope.currentCollection.contents
                                    ? $scope.currentCollection.contents.length
                                    : 0;

                            if ($scope.activeView === "grid") {
                                for (var i = itemsCount; i > 4; i--) {
                                    $($(".menu")[i]).css({
                                        bottom: "60px",
                                        top: "auto",
                                        right: "50px",
                                    });
                                }

                                if (itemsCount <= 4) {
                                    $(".menu").css({
                                        top: "30px",
                                        right: "50px",
                                    });
                                }
                            } else if ($scope.activeView === "list") {
                                $(".menu")
                                    .last()
                                    .css({ top: "auto", bottom: "30px", right: "44px" });

                                if (!$scope.isLMSCourse) {
                                    $(".pnp-item")
                                        .last()
                                        .css("margin-bottom", "40px");
                                }
                            }
                        };

                        var setContainerHeight = function () {
                            logger("setContainerHeight");
                            var contentLoaded = false;

                            var tries = 0;
                            var intervalId = setInterval(function () {
                                tries++;
                                var collectionHeaderHeight =
                                    $("#collection-header").height();
                                var lmsTopHeight = $(
                                    ".ic-app-nav-toggle-and-crumbs"
                                ).height()
                                    ? $(
                                          ".ic-app-nav-toggle-and-crumbs"
                                      ).height()
                                    : 70; //specific for Canvas
                                var availableHeight =
                                    window.innerHeight - lmsTopHeight;
                                var rowListGroupHeight =
                                    $(".row.list-group").height();
                                var createFolderHeight = $(".create-folder")
                                    .length
                                    ? $(".create-folder").height()
                                    : 0;
                                var buttonContainerHeight =
                                    $(".button-container").height();
                                var controlPanelHeight =
                                    $("#control-panel").height();
                                var pnpNavHeight = $("#pnp-nav").height();

                                if (
                                    ($scope.currentCollection &&
                                        $scope.currentCollection.contents &&
                                        $scope.currentCollection.contents
                                            .length) ||
                                    $(".create-folder").is(":visible") ||
                                    tries === 20
                                ) {
                                    rowListGroupHeight = Math.max(
                                        344,
                                        rowListGroupHeight
                                    );
                                    contentLoaded = true;
                                }

                                if (contentLoaded) {
                                    //var spaceForFooter = Math.floor(availableHeight - rowListGroupHeight - createFolderHeight - 24 - buttonContainerHeight - controlPanelHeight - pnpNavHeight - collectionHeaderHeight - 26);
                                    $("#collection-footer").height("");
                                    var cardHeight = $(
                                        $(".item.pnp-item")[1]
                                    ).height()
                                        ? $($(".item.pnp-item")[1]).height()
                                        : $(".item.pnp-item").height();

                                    if ($(".emptyfolder").is(":visible")) {
                                        cardHeight = 0;
                                    }

                                    //Set the height of the content on screen if it's the Pick and Play tab, i.e. there are
                                    //asset cards. If it's the Media Inbox tab, it shouldn't change height.
                                    if(!$scope.isLMSCourse) {
                                        $(".row.list-group .asset-card.create-folder").parents(".row.list-group").height(
                                            $scope.rowsToShow * (cardHeight + 10)
                                        );
                                    }

                                    clearInterval(intervalId);
                                }
                            }, 50);
                        };

                        var showCourseDescriptionEllipsis = function () {
                            logger("showCourseDescriptionEllipsis");
                            $timeout(function () {
                                var courseHeaderDescriptionElement =
                                    angular.element(
                                        "#course-header-description"
                                    );
                                if (
                                    courseHeaderDescriptionElement[0] &&
                                    courseHeaderDescriptionElement[0]
                                        .scrollWidth >
                                        courseHeaderDescriptionElement.innerWidth()
                                ) {
                                    // Description has over-flowed. So show the "Show More" text
                                    $scope.parentCollection.descriptionExpandable = true;
                                    $scope.toggleFullDescription = function () {
                                        $scope.parentCollection.descriptionExpanded =
                                            !$scope.parentCollection
                                                .descriptionExpanded;
                                    };
                                }
                            });
                        };

                        var showCourseBreadCrumbEllipsis = function () {
                            logger("showCourseBreadCrumbEllipsis");
                            $timeout(function () {
                                var collectionTitleElt = angular.element(
                                    "#parent-collection-title-breadcrumb"
                                );
                                $scope.parentCollection.tooltipState =
                                    collectionTitleElt[0] &&
                                    collectionTitleElt[0].scrollWidth >
                                        collectionTitleElt.innerWidth();
                                collectionTitleElt.hover(function () {
                                    $scope.parentCollection.tooltipState =
                                        collectionTitleElt[0] &&
                                        collectionTitleElt[0].scrollWidth >
                                            collectionTitleElt.innerWidth();
                                    $scope.$apply();
                                });
                            });
                        };

                        $scope.$watch("activeLink", function () {
                            logger("watch activeLink");

                            if ($scope.activeLink === "pnp") {
                                showCourseBreadCrumbEllipsis();
                            }
                        });

                        $scope.$watch("render", function () {
                            logger("watch render");

                            if ($scope.render) {
                                $scope.showSpinner();

                                if ($scope.currentCollection.cid == $scope.parentCollection.cid) {
                                    getCollectionContent(
                                        $scope.pagination.current
                                    );
                                    CollectionService.GetCollectionTree.get(
                                        { cid: $state.params.collectionId },
                                        function (tree) {
                                            generateTreePath(tree);
                                            $scope.collectionTree = tree;
                                            $scope.filteredCollectionTree = tree;
                                            $scope.collectionTree.show = false;
                                            $scope.currentCollection.crumbs = generateCrumbs(
                                                $scope.currentCollection.cid,
                                                $scope.currentCollection.path
                                            );
                                        }
                                    );
                                } else {
                                    if (
                                        $scope.renderSource === "Copy" ||
                                        $scope.renderSource === "Move" ||
                                        $scope.renderSource === "Delete"
                                    ) {
                                        $scope.renderSource = null;
                                        getCollectionContent(
                                            $scope.pagination.current
                                        );
                                    } else {
                                        getCollectionContent(1);
                                    }

                                    CollectionService.GetCollectionTree.get(
                                        { cid: $state.params.collectionId },
                                        function (tree) {
                                            generateTreePath(tree);
                                            $scope.collectionTree = tree;
                                            $scope.filteredCollectionTree = tree;
                                            $scope.collectionTree.show = false;
                                            $scope.currentCollection.crumbs =
                                                generateCrumbs(
                                                    $scope.currentCollection
                                                        .cid,
                                                    $scope.currentCollection
                                                        .path
                                                );
                                            if (
                                                $scope.currentCollection
                                                    .pathLength >= 3
                                            ) {
                                                $(
                                                    ".course-breadcrumb-text"
                                                ).css({
                                                    width: "auto",
                                                    "max-width": "40%",
                                                });
                                            } else {
                                                $(
                                                    ".course-breadcrumb-text"
                                                ).css({
                                                    width: "auto",
                                                    "max-width": "95%",
                                                });
                                            }
                                        }
                                    );
                                }

                                $scope.hideSpinner();
                                $scope.render = false;
                            }
                        });

                        var setContentWidthForNewFolder = function () {
                            // if($scope.activeView === 'grid') {
                            //     if($('.asset-card:not(.create-folder)').length) {
                            //         var otherCardsWidth = $('.asset-card:not(.create-folder)').width();
                            //         $('.create-folder').width(otherCardsWidth);
                            //
                            //         // $('#inlineFolderCreate').width(
                            //         //     $('#inlineFolderCreate').find('.asset-card.create-folder').width()
                            //         // );
                            //
                            //         // var titleFieldWidth = $($('.asset-card:not(.create-folder)')[0]).find('input.asset-title').width();
                            //         var titleFieldWidth = '80%';
                            //         $('.create-folder input.asset-title').css('width', '');
                            //         $('.create-folder input.asset-title').width(titleFieldWidth);
                            //
                            //         var titleText = $($('.asset-card:not(.create-folder)')[0]).find('div.asset-title').width();
                            //         $('.create-folder div.folder-title').width(titleText);
                            //
                            //         $('.create-folder div.folder-title-no-hover').width(titleText);
                            //
                            //         var descriptionFieldWidth = $($('.asset-card:not(.create-folder)')[0]).find('textarea.description').width();
                            //         $('.create-folder textarea.description').width(descriptionFieldWidth);
                            //
                            //         var descriptionTextWidth = $($('.asset-card:not(.create-folder)')[0]).find('p.description').width();
                            //         $('.create-folder p.description').width(descriptionTextWidth);
                            //         $('.create-folder p.description-no-hover').width(descriptionTextWidth);
                            //         $('.create-folder p.create-folder-description-placeholder').width(descriptionTextWidth);
                            //     }
                            // }
                            //title input
                            // var divWidth = $('input.create-folder-title-grid').parent().parent().parent().parent().width() - 40;
                            // $('input.create-folder-title-grid').width(divWidth.toString() + 'px');
                            //container width
                            // }
                        };

                        var setContentWidthForList = function () {
                            logger("setContentWidthForList");
                            if ($scope.activeView === "list") {
                                if (window.innerWidth < 800) {
                                    $(".pnp-item").css(
                                        "width",
                                        window.innerWidth - 40 + "px"
                                    );
                                    var pnpItemWidth = $(".pnp-item").width();
                                    // $('.overlayimage.asset-image').width(pnpItemWidth * 0.3);

                                    var imageWidth = $(
                                        ".overlayimage.asset-image"
                                    ).width();
                                    var checkboxWidth = 50;
                                    var mediaIconWidth = 50;
                                    var menuWidth = 38;

                                    var captionWidth =
                                        pnpItemWidth -
                                        imageWidth -
                                        mediaIconWidth -
                                        checkboxWidth -
                                        menuWidth;

                                    var descriptionWidth = captionWidth - 30;
                                    var titleWidth = descriptionWidth - 38;

                                    $("div.folder-title").css(
                                        "width",
                                        titleWidth + "px"
                                    );
                                    $("div.folder-title-no-hover").css(
                                        "width",
                                        titleWidth + "px"
                                    );
                                    $("input.folder-title").css(
                                        "width",
                                        titleWidth + "px"
                                    );
                                    $("div.asset-title").css(
                                        "width",
                                        titleWidth + "px"
                                    );
                                    $("div.asset-title-no-hover").css(
                                        "width",
                                        titleWidth + "px"
                                    );
                                    $("input.asset-title").css(
                                        "width",
                                        titleWidth + "px"
                                    );

                                    $("p.description").css(
                                        "width",
                                        descriptionWidth + "px"
                                    );
                                    $("p.description-no-hover").css(
                                        "width",
                                        descriptionWidth + "px"
                                    );
                                    $(
                                        "p.create-folder-description-placeholder"
                                    ).css("width", descriptionWidth + "px");
                                    $("textarea.description").css(
                                        "width",
                                        descriptionWidth + "px"
                                    );
                                }
                            }else{
                                $(".pnp-item").css("width","");
                            }
                        };

                        var setCardHeight = function (itemHeight) {
                            logger("setCardHeight");
                            if ($scope.activeView === "grid") {
                                $(".pnp-item.grid-group-item").each(
                                    function () {
                                        if (itemHeight) {
                                            $(this).css(
                                                "height",
                                                itemHeight + "px"
                                            );
                                        }
                                    }
                                );
                            } else if ($scope.activeView === "list") {
                                $(".pnp-item.list-group-item").each(function (
                                    item
                                ) {
                                    if (itemHeight) {
                                        $(this).css(
                                            "height",
                                            itemHeight + "px"
                                        );
                                    }
                                });
                            }
                            // calculateThumbnailDimension(assetHeight)
                        };

                        // var calculateThumbnailDimension = function(assetHeight) {
                        //     $('.grid-group-item .overlayimage').each(function() {
                        //         var maxWidth = $(this).parent.parent('.asset-card').innerWidth() - 30;
                        //         var maxHeight = assetHeight - 160,
                        //             width = (maxWidth/16 > maxHeight/9) ? (maxHeight / 9 * 16) : maxHeight,
                        //             height = width / 16 * 9;
                        //
                        //         $(this).css({
                        //             "width" : width + "px",
                        //             "height" : height + "px",
                        //             "margin-left"  : (maxWidth - width)/2,
                        //             "margin-right" : (maxWidth - width)/2
                        //         });
                        //     });
                        // };

                        // This is called for changing between the different content views
                        $scope.changeActiveView = function (view) {
                            logger("changeActiveView");
                            $scope.activeView = view;
                        };

                        $scope.isFirstCallActiveViewCall = true;
                        $scope.$watch("activeView", function () {
                            logger("watch activeView");

                            if ($scope.activeView) {
                                $(".asset-card:not(.create-folder)").css({
                                    backgroundColor: "#FFFFFF",
                                });

                                setSelectAllCheckboxMargin();

                                if ($scope.activeView === "grid") {
                                    //When first loaded, will fill allItemsCollection
                                    if ($scope.currentCollection) {
                                        $scope.currentCollection.contents =
                                            $scope.allItemsCollection;
                                    }

                                    $(".list-group.assets").hide();
                                    $(".pnp-item .overlayimage").css({
                                        width: "100%",
                                        "margin-bottom": "2%",
                                    });

                                    var newCFTitle = $(
                                        ".create-folder-title-list"
                                    ).val();
                                    var newCFDescription = $(
                                        ".create-folder-description-list"
                                    ).val();
                                    var newCFDataXid = $(
                                        ".create-folder-description-list"
                                    )
                                        .parents("[data-xid]")
                                        .attr("data-xid");

                                    setTimeout(function () {
                                        $(".create-folder-description-grid").parents(".asset-card")
                                            .attr(
                                                "data-xid",
                                                newCFDataXid
                                            );
                                        if (
                                            newCFDescription &&
                                            newCFDescription.trim().length
                                        ) {
                                            $(".create-folder-title-grid")
                                                .parent()
                                                .children(
                                                    "div.folder-title-no-hover"
                                                )
                                                .hide();
                                            $(".create-folder-title-grid")
                                                .parent()
                                                .find(
                                                    "div.folder-title-no-hover"
                                                )
                                                .text(newCFTitle);
                                            $(".create-folder-title-grid")
                                                .parent()
                                                .find("div.folder-title")
                                                .hide();
                                            $(".create-folder-title-grid")
                                                .parent()
                                                .find("div.folder-title")
                                                .text(newCFTitle);
                                            $(".create-folder-title-grid")
                                                .parent()
                                                .find("input.folder-title")
                                                .hide();
                                            $(".create-folder-title-grid")
                                                .parent()
                                                .find("input.folder-title")
                                                .val(newCFTitle);
                                            $(".create-folder-title-grid")
                                                .parent()
                                                .find("div.folder-title")
                                                .show();
                                            $(".create-folder-description-grid")
                                                .parent()
                                                .children("p.description")
                                                .hide();
                                            $(".create-folder-description-grid")
                                                .parent()
                                                .children(
                                                    "p.description-no-hover"
                                                )
                                                .hide();
                                            $(".create-folder-description-grid")
                                                .parent()
                                                .children(
                                                    "p.create-folder-description-placeholder"
                                                )
                                                .hide();
                                            $(
                                                ".create-folder-description-grid"
                                            ).val(newCFDescription);
                                            $(
                                                ".create-folder-description-grid"
                                            ).show();
                                            $(
                                                ".create-folder-description-grid"
                                            ).scrollTop(0);
                                            $(
                                                ".create-folder-description-grid"
                                            ).focus();
                                        } else if (
                                            newCFTitle &&
                                            newCFTitle.trim().length
                                        ) {
                                            if (
                                                $scope.hasFocusInCFDescription
                                            ) {
                                                $(".create-folder-title-grid")
                                                    .parent()
                                                    .find("input.folder-title")
                                                    .hide();
                                                $(".create-folder-title-grid")
                                                    .parent()
                                                    .find("input.folder-title")
                                                    .val(newCFTitle);
                                                $(".create-folder-title-grid")
                                                    .parent()
                                                    .find(
                                                        "div.folder-title-no-hover"
                                                    )
                                                    .hide();
                                                $(".create-folder-title-grid")
                                                    .parent()
                                                    .find(
                                                        "div.folder-title-no-hover"
                                                    )
                                                    .text(newCFTitle);
                                                $(".create-folder-title-grid")
                                                    .parent()
                                                    .find("div.folder-title")
                                                    .text(newCFTitle);
                                                $(".create-folder-title-grid")
                                                    .parent()
                                                    .find("div.folder-title")
                                                    .show();

                                                $(".create-folder-title-grid")
                                                    .parent()
                                                    .parent()
                                                    .find("p.description")
                                                    .hide();
                                                $(".create-folder-title-grid")
                                                    .parent()
                                                    .parent()
                                                    .find(
                                                        "p.description-no-hover"
                                                    )
                                                    .hide();
                                                $(".create-folder-title-grid")
                                                    .parent()
                                                    .parent()
                                                    .find(
                                                        "p.create-folder-description-placeholder"
                                                    )
                                                    .hide();
                                                $(".create-folder-title-grid")
                                                    .parent()
                                                    .parent()
                                                    .find(
                                                        "textarea.description"
                                                    )
                                                    .show();
                                                $(".create-folder-title-grid")
                                                    .parent()
                                                    .parent()
                                                    .find(
                                                        "textarea.description"
                                                    )
                                                    .focus();
                                            } else {
                                                $(".create-folder-title-grid")
                                                    .parent()
                                                    .children(
                                                        "div.folder-title-no-hover"
                                                    )
                                                    .hide();
                                                $(".create-folder-title-grid")
                                                    .parent()
                                                    .find(
                                                        "div.folder-title-no-hover"
                                                    )
                                                    .text(newCFTitle);
                                                $(".create-folder-title-grid")
                                                    .parent()
                                                    .find("div.folder-title")
                                                    .hide();
                                                $(".create-folder-title-grid")
                                                    .parent()
                                                    .find("div.folder-title")
                                                    .text(newCFTitle);
                                                $(".create-folder-title-grid")
                                                    .parent()
                                                    .find("input.folder-title")
                                                    .val(newCFTitle);
                                                $(".create-folder-title-grid")
                                                    .parent()
                                                    .find("input.folder-title")
                                                    .show();
                                                $(".create-folder-title-grid")
                                                    .parent()
                                                    .find("input.folder-title")
                                                    .focus();
                                                var descriptionText = $(".create-folder-title-grid")
                                                    .parent()
                                                    .parent()
                                                    .find(
                                                        "textarea.description"
                                                    ).val();
                                                if(descriptionText.length){
                                                    $(".create-folder-title-grid")
                                                        .parent()
                                                        .parent()
                                                        .find(
                                                            "p.description-no-hover"
                                                        )
                                                        .show();
                                                    $(".create-folder-title-grid")
                                                        .parent()
                                                        .parent()
                                                        .find(
                                                            "p.create-folder-description-placeholder"
                                                        )
                                                        .hide();
                                                }else{
                                                    $(".create-folder-title-grid")
                                                        .parent()
                                                        .parent()
                                                        .find(
                                                            "p.description-no-hover"
                                                        )
                                                        .hide();
                                                    $(".create-folder-title-grid")
                                                        .parent()
                                                        .parent()
                                                        .find(
                                                            "p.create-folder-description-placeholder"
                                                        )
                                                        .show();
                                                }
                                                $(".create-folder-title-grid")
                                                        .parent()
                                                        .parent()
                                                        .find("p.description")
                                                        .hide();
                                                $(".create-folder-title-grid")
                                                    .parent()
                                                    .parent()
                                                    .find(
                                                        "textarea.description"
                                                    )
                                                    .hide();
                                            }
                                        }
                                    }, 100);

                                    $(".assets").css("opacity", "0");
                                } else if ($scope.activeView === "list") {
                                    $scope.currentCollection.contents =
                                        $scope.allItemsCollection.slice(0, 8);

                                    $(".pnp-item .overlayimage").css({
                                        height: "130px",
                                        width: "25%",
                                        margin: 0,
                                    });

                                    var newCFTitle = $(
                                        ".create-folder-title-grid"
                                    ).val();
                                    var newCFDescription = $(
                                        ".create-folder-description-grid"
                                    ).val();
                                    var newCFDataXid = $(
                                        ".create-folder-description-grid"
                                    )
                                        .parents("[data-xid]")
                                        .attr("data-xid");

                                    setTimeout(function () {
                                        $(".create-folder-description-list").parents(".asset-card")
                                        .attr(
                                            "data-xid",
                                            newCFDataXid
                                        );
                                        if (
                                            newCFDescription &&
                                            newCFDescription.trim().length
                                        ) {
                                            $(".create-folder-title-list")
                                                .parent()
                                                .children(
                                                    "div.folder-title-no-hover"
                                                )
                                                .hide();
                                            $(".create-folder-title-list")
                                                .parent()
                                                .find(
                                                    "div.folder-title-no-hover"
                                                )
                                                .text(newCFTitle);
                                            $(".create-folder-title-list")
                                                .parent()
                                                .find("div.folder-title")
                                                .hide();
                                            $(".create-folder-title-list")
                                                .parent()
                                                .find("div.folder-title")
                                                .text(newCFTitle);
                                            $(".create-folder-title-list")
                                                .parent()
                                                .find("input.folder-title")
                                                .hide();
                                            $(".create-folder-title-list")
                                                .parent()
                                                .find("input.folder-title")
                                                .val(newCFTitle);
                                            $(".create-folder-title-list")
                                                .parent()
                                                .find("div.folder-title")
                                                .show();
                                            $(".create-folder-description-list")
                                                .parent()
                                                .children("p.description")
                                                .hide();
                                            $(".create-folder-description-list")
                                                .parent()
                                                .children(
                                                    "p.description-no-hover"
                                                )
                                                .hide();
                                            $(".create-folder-description-list")
                                                .parent()
                                                .children(
                                                    "p.create-folder-description-placeholder"
                                                )
                                                .hide();
                                            $(
                                                ".create-folder-description-list"
                                            ).val(newCFDescription);
                                            $(
                                                ".create-folder-description-list"
                                            ).show();
                                            $(
                                                ".create-folder-description-list"
                                            ).scrollTop(0);
                                            $(
                                                ".create-folder-description-list"
                                            ).focus();
                                        } else if (
                                            newCFTitle &&
                                            newCFTitle.trim().length
                                        ) {
                                            if (
                                                $scope.hasFocusInCFDescription
                                            ) {
                                                $(".create-folder-title-list")
                                                    .parent()
                                                    .find("input.folder-title")
                                                    .hide();
                                                $(".create-folder-title-list")
                                                    .parent()
                                                    .find("input.folder-title")
                                                    .val(newCFTitle);
                                                $(".create-folder-title-list")
                                                    .parent()
                                                    .find(
                                                        "div.folder-title-no-hover"
                                                    )
                                                    .hide();
                                                $(".create-folder-title-list")
                                                    .parent()
                                                    .find(
                                                        "div.folder-title-no-hover"
                                                    )
                                                    .text(newCFTitle);
                                                $(".create-folder-title-list")
                                                    .parent()
                                                    .find("div.folder-title")
                                                    .text(newCFTitle);
                                                $(".create-folder-title-list")
                                                    .parent()
                                                    .find("div.folder-title")
                                                    .show();

                                                $(".create-folder-title-list")
                                                    .parent()
                                                    .parent()
                                                    .find("p.description")
                                                    .hide();
                                                $(".create-folder-title-list")
                                                    .parent()
                                                    .parent()
                                                    .find(
                                                        "p.description-no-hover"
                                                    )
                                                    .hide();
                                                $(".create-folder-title-list")
                                                    .parent()
                                                    .parent()
                                                    .find(
                                                        "p.create-folder-description-placeholder"
                                                    )
                                                    .hide();
                                                $(".create-folder-title-list")
                                                    .parent()
                                                    .parent()
                                                    .find(
                                                        "textarea.description"
                                                    )
                                                    .show();
                                                $(".create-folder-title-list")
                                                    .parent()
                                                    .parent()
                                                    .find(
                                                        "textarea.description"
                                                    )
                                                    .focus();
                                            } else {
                                                $(".create-folder-title-list")
                                                    .parent()
                                                    .children(
                                                        "div.folder-title-no-hover"
                                                    )
                                                    .hide();
                                                $(".create-folder-title-list")
                                                    .parent()
                                                    .find(
                                                        "div.folder-title-no-hover"
                                                    )
                                                    .text(newCFTitle);
                                                $(".create-folder-title-list")
                                                    .parent()
                                                    .find("div.folder-title")
                                                    .hide();
                                                $(".create-folder-title-list")
                                                    .parent()
                                                    .find("div.folder-title")
                                                    .text(newCFTitle);
                                                $(".create-folder-title-list")
                                                    .parent()
                                                    .find("input.folder-title")
                                                    .val(newCFTitle);
                                                $(".create-folder-title-list")
                                                    .parent()
                                                    .find("input.folder-title")
                                                    .show();
                                                $(".create-folder-title-list")
                                                    .parent()
                                                    .find("input.folder-title")
                                                    .focus();
                                            }
                                        }
                                    }, 100);

                                }

                                $(".assets").show();

                                if ($scope.activeView === "grid") {
                                    if (
                                        $("#inlineFolderCreate").is(
                                            ":visible"
                                        ) &&
                                        $scope.currentCollection &&
                                        $scope.currentCollection.contents
                                    ) {

                                        if (
                                            $scope.rowsToShow === 3 &&
                                            $scope.currentCollection.contents
                                                .length === 12
                                        ) {
                                            $(".item.pnp-item").last().hide();
                                        }

                                        if (
                                            $scope.rowsToShow === 2 &&
                                            $scope.currentCollection.contents
                                                .length === 8
                                        ) {
                                            $(".item.pnp-item").last().hide();
                                        }

                                        if (
                                            $scope.rowsToShow === 1 &&
                                            $scope.currentCollection.contents
                                                .length === 4
                                        ) {
                                            $(".item.pnp-item").last().hide();
                                        }
                                    }
                                }

                                if (!$scope.isFirstCallActiveViewCall) {
                                    makeContentResponsive("changeView");
                                }

                                setTimeout(function () {
                                    // $('.list-group.assets').show();
                                    $scope.manageCheckAllState();
                                }, 0);

                                $scope.isFirstCallActiveViewCall = false;
                            }
                        });

                        $scope.toggleFilterAndSort = function () {
                            logger("toggleFilterAndSort");
                            $scope.showFilterAndSort =
                                !$scope.showFilterAndSort;
                            $("#filtertoggle").attr("aria-expanded",$scope.showFilterAndSort);

                            setTimeout(() => {
                                    if($scope.showFilterAndSort){
                                        $("#closeFilterMenuButton").focus();
                                    }else{
                                        $("#filtertoggle").focus();
                                    }
                                }, 100);
                        };

                        $scope.toggleFilter = function (filter) {
                            logger("toggleFilter");
                            filter.selected = !filter.selected;
                        };

                        $scope.toggleSearch = function (doFocus) {
                            logger("toggleSearch");
                            if(doFocus===undefined){
                                doFocus=true;
                            }
                            $scope.search.activateSearch =
                                !$scope.search.activateSearch;
                            if (!$scope.search.activateSearch) {
                                $scope.search.query = "";
                                $scope.showSearchResults = false;
                                $scope.filteredCollectionTree = $scope.collectionTree;
                            }
                            $("#toggleSearchButton").attr("aria-expanded",$scope.search.activateSearch);
                            if(doFocus){
                                $timeout(function () {
                                    if ($scope.search.activateSearch) {
                                        $("#searchbox").focus();
                                    }else{
                                        $("#toggleSearchButton").focus();
                                    }
                                });
                            }
                        };

                        $scope.setActiveSort = function (sort) {
                            logger("setActiveSort");
                            $scope.activeSortId =
                                $scope.activeSortId === sort.id ? "" : sort.id;
                        };

                        $scope.resetFilterAndSort = function () {
                            logger("resetFilterAndSort");
                            angular.forEach($scope.filters, function (filter) {
                                filter.selected = false;
                            });
                            $scope.activeSortId = "publishedDate";
                            $scope.filterAndSortText = "Filter / Sort";
                            $scope.filterApplied = false;
                        };

                        $scope.clearFilterAndSort = function (event) {
                            logger("clearFilterAndSort");
                            event.stopPropagation();
                            $scope.resetFilterAndSort();
                            $scope.applyFilterAndSort();
                        };

                        $scope.applyFilterAndSort = function () {
                            logger("applyFilterAndSort");
                            $scope.pagination.current = 1;
                            getCollectionContent(1);
                            var selectedFilters = $filter("filter")(
                                    $scope.filters,
                                    { selected: true },
                                    true
                                ),
                                selectedSort = $filter("filter")(
                                    $scope.sorts,
                                    { id: $scope.activeSortId },
                                    true
                                );
                            if (selectedFilters.length || selectedSort.length) {
                                var selectedSortName = selectedSort.length
                                    ? selectedSort[0].name
                                    : "N/A";
                                $scope.filterAndSortText =
                                    "<b>" +
                                    selectedFilters.length +
                                    " Filters </b> / Sort By <b>" +
                                    selectedSortName +
                                    "</b>";
                            } else {
                                $scope.filterAndSortText = "Filter / Sort";
                            }
                            if (selectedFilters.length) {
                                $scope.filterApplied = true;
                            }
                            $scope.showFilterAndSort = false;
                        };

                        $scope.findContent = function () {
                            logger("findContent");

                            var query = $scope.search.query;
                            if (query) {
                                SearchService.SearchAssets.get(
                                    {
                                        query: query,
                                        sitewide: false,
                                        cid: $scope.parentCollection.cid,
                                        limit: 200,
                                        offset: 0,
                                        active: !$scope.unpublished
                                    },
                                    function (contentList) {
                                        var collectionIdList = [],
                                            searchResults = [];

                                        angular.forEach(
                                            contentList.contents,
                                            function (result) {
                                                var parent = result.parent;
                                                if (
                                                    collectionIdList.indexOf(
                                                        parent.cid
                                                    ) === -1
                                                ) {
                                                    parent.crumbs =
                                                        generateCrumbs(
                                                            parent.cid,
                                                            parent.path
                                                        );
                                                    collectionIdList.push(
                                                        parent.cid
                                                    );
                                                    searchResults.push({
                                                        parent: parent,
                                                        pathLength:
                                                            parent.path.split(
                                                                "/"
                                                            ).length,
                                                        hits: $filter("filter")(
                                                            contentList.contents,
                                                            {
                                                                parent: {
                                                                    cid: parent.cid,
                                                                },
                                                            },
                                                            true
                                                        ),
                                                    });
                                                }
                                            }
                                        );

                                        $scope.searchResults = {
                                            searchTerm: query,
                                            hits: searchResults,
                                            totalHits:
                                                contentList.contents.length,
                                        };
                                        $scope.showSearchResults = true;
                                        $scope.currentCollection = $scope.rootLevelCollection;
                                        $scope.filteredCollectionTree = { children:[] };
                                    }
                                );
                            } else {
                                $scope.showSearchResults = false;
                            }
                        };

                        $scope.publishItems = function () {
                            logger("publishItems");
                            var xids = [];
                            if ($scope.activeView === "list") {
                                $.each(
                                    $(".item-checkbox:checked"),
                                    function (k, v) {
                                        console.log($(v));
                                        xids.push(
                                            $(v)
                                                .data("xid")
                                        );
                                    }
                                );
                            } else {
                                $.each(
                                    $(".item-checkbox:checked"),
                                    function (k, v) {
                                        console.log($(v));
                                        xids.push(
                                            $(v)
                                                .data("xid")
                                        );
                                    }
                                );
                            }

                            var items = [];
                            var filteredArray =
                                $scope.currentCollection.contents.filter(
                                    (el) => {
                                        return xids.some((f) => {
                                            return f === el.xid;
                                        });
                                    }
                                );
                            $.each(filteredArray, function (k, file) {
                                var item = {};
                                item.assetId = file.xid;
                                item.active = true;
                                items.push(item);
                            });

                            console.log("Operation: Publish");
                            console.log("Items: ", items);
                            console.log("Items Length: ", items.length);

                            $scope.openModal("Publish");
                        };

                        $scope.confirmDeleteItem = function () {
                            logger("confirmDeleteItem");
                            $("#delete-modal").modal("show");
                            var checked = $(".item-checkbox:checked");
                            if (checked.length > 2) {
                                $("#delete-modal #myModalHeadline").text(
                                    "Delete Items (" + checked.length + ")?"
                                );
                                $("#delete-modal .modal-body p").text(
                                    "Selecting “Delete” will delete these items as well as any items stored in them. This action cannot be undone."
                                );
                                $("#delete-modal").modal("show");
                            } else if (checked.length === 1) {
                                var xid = $(checked[0])
                                    .parent()
                                    .parent()
                                    .parent()
                                    .parent()
                                    .data("xid");
                                var content =
                                    $scope.currentCollection.contents.find(
                                        (el) => el.xid === xid
                                    );
                                console.log("content: ", content);
                                if (content) {
                                    var title = content.title;
                                    var modalHeadline = "";
                                    var modalBody = "";
                                    if("Quiz" === content.type){
                                        modalHeadline = "Delete Published Quiz?";
                                        if(!$scope.unpublished){
                                            modalBody = "This quiz is published, i.e., it is available to students and other authorized users. "+
                                                "If you select “Delete”, the quiz will be permanently deleted and students will not be able to access it. "+
                                                "Deleting a quiz cannot be undone.";
                                        }else{
                                            modalBody = "If you select “Delete”, the quiz will be permanently deleted. Deleting a quiz cannot be undone.";
                                        }
                                    }else if("Collection" === content.type){
                                        modalHeadline = "Delete Folder?";
                                        modalBody = 'Deleting the “' + title + '” Folder will delete the Folder as well as any items stored in it. This action cannot be undone.';
                                    }else {
                                        modalHeadline = "Delete Media Asset?";
                                        modalBody = 'This action cannot be undone.';
                                    }
                                    $("#delete-modal #myModalHeadline").text(modalHeadline);
                                    $("#delete-modal .modal-body p").text(modalBody);
                                }
                            } else if (checked.length === 2) {
                                var nameArr = ["", "and", ""];
                                var first = $(checked[0])
                                    .parent()
                                    .parent()
                                    .parent()
                                    .parent()
                                    .data("xid");
                                var second = $(checked[1])
                                    .parent()
                                    .parent()
                                    .parent()
                                    .parent()
                                    .data("xid");
                                var firstName =
                                    '"' +
                                    $scope.currentCollection.contents.find(
                                        (el) => el.xid === first
                                    ).title +
                                    '"';
                                var secondName =
                                    '"' +
                                    $scope.currentCollection.contents.find(
                                        (el) => el.xid === second
                                    ).title +
                                    '"';
                                $("#delete-modal #myModalHeadline").text(
                                    "Delete Items (2)?"
                                );
                                $("#delete-modal .modal-body p").text(
                                    firstName +
                                        " and " +
                                        secondName +
                                        ", as well as any items stored in them, will be deleted.  This action cannot be undone."
                                );
                            } else {
                                return;
                            }
                        };

                        $scope.deleteItem = function () {
                            logger("confirmDeleteItem");
                            var xids = [];

                            $.each(
                                $(".item-checkbox:checked"),
                                function (k, v) {
                                    console.log($(v));
                                    xids.push(
                                        $(v)
                                            .data("xid")
                                    );
                                }
                            );

                            var items = [];
                            var filteredArray =
                                $scope.currentCollection.contents.filter(
                                    (el) => {
                                        return xids.some((f) => {
                                            return f === el.xid;
                                        });
                                    }
                                );
                            $.each(filteredArray, function (k, file) {
                                var item = {};
                                item.collectionContentDTO = file;
                                item.destinationCollectionId =
                                    $scope.currentCollection.cid;
                                items.push(item);
                            });

                            console.log("Operation: Delete");
                            console.log("Items: ", items);
                            console.log("Items Length: ", items.length);

                            var deleteItem = new BaseFileService.DeleteItem({
                                contents: items,
                                totalContents: items.length,
                            });
                            deleteItem.$save(
                                function (response) {
                                    console.log("deleteItem resp: ", response);
                                    $("#delete-modal").modal("hide");
                                    $scope.renderSource = "Delete";
                                    $scope.render = true;
                                },
                                function () {}
                            );
                        };

                        $scope.showSpinner = function () {
                            logger("showSpinner");
                            $(".overlay-main").css("width", "100%");
                            $(".overlay-main").css("height", "100%");
                            $(".overlay-main").show();
                        };

                        $scope.hideSpinner = function () {
                            logger("hideSpinner");
                            $(".overlay-main").css("width", "0%");
                            $(".overlay-main").css("height", "0%");
                            $(".overlay-main").hide();
                        };

                        $scope.showCreateFolder = function () {
                            logger("showCreateFolder");
                            $scope.showSpinner();
                            $(".new-folder-checkbox").attr("checked", false);
                            $scope.pagination.current = 1;
                            $scope.getCollectionContent(1);
                            $timeout(function () {
                                $scope.currentCollection.createdFolder = null;
                                var count = 1;
                                // $.each($scope.currentCollection.contents, function (k, v) {
                                $.each(
                                    $scope.currentCollection.childCollections,
                                    function (k, v) {
                                        if (
                                            v.title.includes("Untitled Folder")
                                        ) {
                                            count++;
                                        }
                                    }
                                );
                                // var num = pad(count);
                                var num = count;
                                var untitled =
                                    num != "01"
                                        ? "Untitled Folder " + num
                                        : "Untitled Folder";
                                var createFolder =
                                    new CollectionService.CreateCollection({
                                        title: untitled,
                                        type: "Collection",
                                        contributor: $scope.account.login,
                                        description: "",
                                        lmsCourseId: "",
                                        active: "1",
                                        lockContentOrder: 0,
                                        parentCollectionId:
                                            $scope.currentCollection.cid,
                                    });
                                createFolder.$save(
                                    function (response) {
                                        console.log(
                                            "createFolder resp: ",
                                            response
                                        );

                                        //TODO: think of edge cases. Ex: User deletes, copies or moves card while in CF mode
                                        //Solution #1: hide or show last card everytime a change happens in the current collection
                                        if ($(".asset-card").length > 8) {
                                            $(".item.pnp-item").last().hide();
                                        } else {
                                            $(".item.pnp-item").last().show();
                                        }

                                        $("#inlineFolderCreate").show();

                                        $(
                                            "#inlineFolderCreate .asset-card"
                                        ).attr("data-xid", response.result);

                                        var collectionObj = {
                                            title: "",
                                            description: "",
                                            xid: response.result,
                                            type: "Collection",
                                        };

                                        $scope.currentCollection.totalContents =
                                            $scope.currentCollection
                                                .totalContents + 1;
                                        $scope.currentCollection.createdFolder =
                                            collectionObj;
                                        $scope.parentCollection.childCollections.push(
                                            collectionObj
                                        );
                                        $scope.copyWizardAvailable = false;
                                        $scope.hideSpinner();

                                        //focus on text input
                                        if ($scope.activeView === "grid") {
                                            $(".create-folder-title-grid")
                                                .parent()
                                                .children(".folder-title")
                                                .text("");
                                            $(".create-folder-title-grid")
                                                .parent()
                                                .children(
                                                    ".folder-title-no-hover"
                                                )
                                                .text("");
                                            $(".create-folder-title-grid")
                                                .parent()
                                                .children(".folder-title")
                                                .hide();
                                            $(".create-folder-title-grid")
                                                .parent()
                                                .children(
                                                    ".folder-title-no-hover"
                                                )
                                                .hide();
                                            $(".create-folder-title-grid").val(
                                                ""
                                            );
                                            $(
                                                ".create-folder-title-grid"
                                            ).show();

                                            var idTimeout = setTimeout(
                                                function () {
                                                    if (
                                                        $(
                                                            "#inlineFolderCreate"
                                                        ).is(":visible")
                                                    ) {
                                                        $(
                                                            ".create-folder-title-grid"
                                                        ).focus();
                                                        $('.row.list-group.assets').css('height', '100%');
                                                        clearTimeout(idTimeout);
                                                    }
                                                },
                                                100
                                            );

                                            $(
                                                $(".create-folder-title-grid")
                                                    .parent()
                                                    .parent()
                                                    .children()[1]
                                            )
                                                .children("p")
                                                .val("");
                                            $(
                                                $(".create-folder-title-grid")
                                                    .parent()
                                                    .parent()
                                                    .children()[1]
                                            )
                                                .children("p")
                                                .text("");
                                            $(
                                                $(".create-folder-title-grid")
                                                    .parent()
                                                    .parent()
                                                    .children()[1]
                                            )
                                                .children("p")
                                                .hide();
                                            $(
                                                $(".create-folder-title-grid")
                                                    .parent()
                                                    .parent()
                                                    .children()[1]
                                            )
                                                .children("textarea")
                                                .hide();
                                            $(
                                                $(".create-folder-title-grid")
                                                    .parent()
                                                    .parent()
                                                    .children()[1]
                                            )
                                                .children("textarea")
                                                .val("");
                                            $(
                                                $(".create-folder-title-grid")
                                                    .parent()
                                                    .parent()
                                                    .children()[1]
                                            )
                                                .children(
                                                    ".create-folder-description-placeholder"
                                                )
                                                .text("Enter a description");
                                            $(
                                                $(".create-folder-title-grid")
                                                    .parent()
                                                    .parent()
                                                    .children()[1]
                                            )
                                                .children(
                                                    ".create-folder-description-placeholder"
                                                )
                                                .show();
                                        } else if (
                                            $scope.activeView === "list"
                                        ) {
                                            $(".create-folder-title-list")
                                                .parent()
                                                .children(".folder-title")
                                                .text("");
                                            $(".create-folder-title-list")
                                                .parent()
                                                .children(
                                                    ".folder-title-no-hover"
                                                )
                                                .text("");
                                            $(".create-folder-title-list")
                                                .parent()
                                                .children(".folder-title")
                                                .hide();
                                            $(".create-folder-title-list")
                                                .parent()
                                                .children(
                                                    ".folder-title-no-hover"
                                                )
                                                .hide();
                                            $(".create-folder-title-list").val(
                                                ""
                                            );
                                            $(
                                                ".create-folder-title-list"
                                            ).show();

                                            var idTimeout = setTimeout(
                                                function () {
                                                    if (
                                                        $(
                                                            "#inlineFolderCreate"
                                                        ).is(":visible")
                                                    ) {
                                                        $(
                                                            ".create-folder-title-list"
                                                        ).focus();
                                                        clearTimeout(idTimeout);
                                                    }
                                                },
                                                100
                                            );

                                            $(
                                                $(".create-folder-title-list")
                                                    .parent()
                                                    .parent()
                                                    .children()[1]
                                            )
                                                .children("p")
                                                .val("");
                                            $(
                                                $(".create-folder-title-list")
                                                    .parent()
                                                    .parent()
                                                    .children()[1]
                                            )
                                                .children("p")
                                                .text("");
                                            $(
                                                $(".create-folder-title-list")
                                                    .parent()
                                                    .parent()
                                                    .children()[1]
                                            )
                                                .children("p")
                                                .hide();
                                            $(
                                                $(".create-folder-title-list")
                                                    .parent()
                                                    .parent()
                                                    .children()[1]
                                            )
                                                .children("textarea")
                                                .hide();
                                            $(
                                                $(".create-folder-title-list")
                                                    .parent()
                                                    .parent()
                                                    .children()[1]
                                            )
                                                .children("textarea")
                                                .val("");
                                            $(
                                                $(".create-folder-title-list")
                                                    .parent()
                                                    .parent()
                                                    .children()[1]
                                            )
                                                .children(
                                                    ".create-folder-description-placeholder"
                                                )
                                                .text("Enter a description");
                                            $(
                                                $(".create-folder-title-list")
                                                    .parent()
                                                    .parent()
                                                    .children()[1]
                                            )
                                                .children(
                                                    ".create-folder-description-placeholder"
                                                )
                                                .show();
                                        }

                                        $scope.loadComponent("pnp");
                                    },
                                    function () {}
                                );
                            }, 1000);
                        };

                        // For accessible modals
                        var modalFocus = function (first, last) {
                            logger("modalFocus");
                            var firstItem = $(first),
                                lastItem = $(last);

                            /*set focus on first item*/
                            firstItem.focus();

                            /*redirect last tab to first input*/
                            lastItem.on("keydown", function (e) {
                                if (e.which === 9 && !e.shiftKey) {
                                    e.preventDefault();
                                    firstItem.focus();
                                }
                            });

                            /*redirect first shift+tab to last input*/
                            firstItem.on("keydown", function (e) {
                                if (e.which === 9 && e.shiftKey) {
                                    e.preventDefault();
                                    lastItem.focus();
                                }
                            });
                        };

                        function pad(d) {
                            return d < 10 ? "0" + d.toString() : d.toString();
                        }

                        var removeHTMLTags = function (value) {
                            var processedText = value.replaceAll("<", "&lt;");
                            processedText = processedText.replaceAll(
                                ">",
                                "&gt;"
                            );
                            return processedText;
                        };

                        $scope.updateItem = function (xid) {
                            logger("updateItem");
                            var itemToUpdate =
                                $scope.currentCollection.createdFolder;
                            var titleField = $(
                                'div[data-xid="' + xid + '"] input.asset-title'
                            );

                            ////Getting the last time we used Untitled Folder, get its number and give it the next
                            var untitledFolderLength = "Untitled Folder".length;
                            var nextUntitledFolderNumber;
                            var fullListFolderNumber;
                            var currentPageFolderNumber;

                            //Get next Untitled Folder number from full list (not updated after updating the list)
                            var newestUntitledFolder =
                                $scope.currentCollection.childCollections
                                    .reverse()
                                    .find((p) =>
                                        p.title.includes("Untitled Folder")
                                    );
                            if (newestUntitledFolder) {
                                if (
                                    newestUntitledFolder.title.length >
                                    untitledFolderLength
                                ) {
                                    try {
                                        fullListFolderNumber = parseInt(
                                            newestUntitledFolder.title.substring(
                                                untitledFolderLength
                                            )
                                        );
                                    } catch (e) {
                                        fullListFolderNumber = 1;
                                    }
                                } else {
                                    fullListFolderNumber = 1;
                                }
                            } else {
                                fullListFolderNumber = 0;
                            }

                            //Get next Untitled Folder number from current page
                            var currentPageNewestFolder =
                                $scope.currentCollection.contents.find((p) =>
                                    p.title.includes("Untitled Folder")
                                );
                            if (currentPageNewestFolder) {
                                if (
                                    currentPageNewestFolder.title.length >
                                    untitledFolderLength
                                ) {
                                    try {
                                        currentPageFolderNumber = parseInt(
                                            currentPageNewestFolder.title.substring(
                                                untitledFolderLength
                                            )
                                        );
                                    } catch (e) {
                                        currentPageFolderNumber = 1;
                                    }
                                } else {
                                    currentPageFolderNumber = 1;
                                }
                            } else {
                                currentPageFolderNumber = 0;
                            }

                            //Compare current page with full list
                            if (
                                fullListFolderNumber > currentPageFolderNumber
                            ) {
                                nextUntitledFolderNumber =
                                    fullListFolderNumber + 1;
                            } else if (currentPageFolderNumber > 1) {
                                nextUntitledFolderNumber =
                                    currentPageFolderNumber + 1;
                            } else if (
                                currentPageFolderNumber === 0 &&
                                fullListFolderNumber === 0
                            ) {
                                nextUntitledFolderNumber = 1;
                            } else if (
                                currentPageFolderNumber === 1 ||
                                fullListFolderNumber === 1
                            ) {
                                nextUntitledFolderNumber = 2;
                            }

                            var untitled =
                                nextUntitledFolderNumber != "1"
                                    ? "Untitled Folder " +
                                      nextUntitledFolderNumber
                                    : "Untitled Folder";

                            if (
                                titleField.val() &&
                                titleField.val().trim().length
                            ) {
                                itemToUpdate.title = removeHTMLTags(
                                    titleField.val().trim()
                                );
                            } else {
                                itemToUpdate.title = untitled;
                                $(
                                    'div[data-xid="' + xid + '"] .asset-title'
                                ).val(untitled);
                            }

                            var descriptionField = $(
                                'div[data-xid="' + xid + '"] textarea'
                            );
                            if (descriptionField.val()) {
                                itemToUpdate.description = removeHTMLTags(
                                    descriptionField.val().trim()
                                );
                            } else {
                                itemToUpdate.description = "";
                            }

                            var updateItem = new BaseFileService.UpdateItem({
                                collectionContentDTO: itemToUpdate,
                                destinationCollectionId:
                                    $scope.currentCollection.cid,
                            });
                            updateItem.$save(
                                function (response) {
                                    console.log("updateItem resp: ", response);
                                },
                                function () {}
                            );
                        };

                        $("#folderTitleDivList").blur(function (e, t) {
                            logger("folderTitleDivList blur");
                            // trap the return key being pressed
                            var updatedXid = $(this)
                                .parent()
                                .parent()
                                .parent()
                                .data("xid");
                            $scope.updateItem(updatedXid);
                            return false;
                        });

                        $("#folderDescriptionPList").blur(function (e) {
                            logger("folderDescriptionPList blur");
                            // trap the return key being pressed
                            var updatedXid = $(this)
                                .parent()
                                .parent()
                                .data("xid");
                            $scope.updateItem(updatedXid);
                            return false;
                        });

                        $scope.isPersistingTitle = false;

                        $scope.handleInputTitleKeyPress = function (e) {
                            logger("handleInputTitleKeyPress");
                            if (e.keyCode === 13) {
                                $scope.persistTitle({
                                    titleField: e.target,
                                    shouldRefreshContent: false,
                                    shouldFocusOnDescription: true,
                                });
                            }
                        };

                        $scope.handleInputTitleBlur = function (e) {
                            $scope.persistTitle({
                                titleField: e.target,
                                shouldFocusOnDescription: true,
                            });
                        };

                        $scope.manageCheckAllState = function (e) {
                            logger("manageCheckAllState");

                            var checkboxList = document.querySelectorAll(
                                ".asset-card .item-checkbox:not(.new-folder-checkbox)"
                            );
                            var checkAllCheckbox = document.querySelector(
                                "#selectAllCheck"
                            );

                            var allChecked = true;
                            var uncheckedCount = 0;

                            for (let checkbox of checkboxList) {
                                if (!checkbox.checked) {
                                    allChecked = false;
                                    uncheckedCount++;
                                }
                            }

                            if (checkAllCheckbox) {
                                //all selected
                                if (allChecked) {
                                    checkAllCheckbox.setAttribute("aria-checked","true");
                                }

                                //some selected
                                if (
                                    !allChecked &&
                                    uncheckedCount < checkboxList.length &&
                                    uncheckedCount > 0
                                ) {
                                    checkAllCheckbox.setAttribute("aria-checked","mixed");
                                }

                                //none selected
                                if (uncheckedCount === checkboxList.length) {
                                    checkAllCheckbox.setAttribute("aria-checked","false");
                                }
                            }
                        };

                        var selectedCheckboxes = [];
                        var saveSelectedCheckboxes = function () {
                            logger("saveSelectedCheckboxes");
                            selectedCheckboxes = [];

                            $(
                                '.asset-card:not(.create-folder) input[type="checkbox"]'
                            ).each((index, item) => {
                                if ($(item)[0].checked) {
                                    selectedCheckboxes.push(index);
                                }
                            });

                            //If the Select All checkbox is selected, we call it -1
                            if (typeof($("#selectAllCheck input")[0])!=="undefined"  && $("#selectAllCheck input")[0].checked) {
                                selectedCheckboxes.push(-1);
                            }
                        };

                        var selectCheckboxes = function () {
                            logger("selectCheckboxes");

                            for (
                                var i = 0;
                                i < selectedCheckboxes.length;
                                i++
                            ) {
                                if (selectedCheckboxes[i] === -1) {
                                    setTimeout(() => {
                                        $("#selectAllCheck input")[0].click();
                                    }, 100);
                                }

                                if (selectedCheckboxes[i] > -1) {
                                    if (
                                        $(
                                            '.asset-card:not(.create-folder) input[type="checkbox"]'
                                        )[selectedCheckboxes[i] + 1]
                                    ) {
                                        $(
                                            '.asset-card:not(.create-folder) input[type="checkbox"]'
                                        )[
                                            selectedCheckboxes[i] + 1
                                        ].checked = true;
                                    }
                                }
                            }

                            $scope.manageCheckAllState();

                            if ($("#selectAllCheck")[0].checked) {
                                $(
                                    '.asset-card:not(.create-folder) input[type="checkbox"]'
                                )[0].checked = true;
                            }

                            $scope.setSelectedItemsBgColor();
                        };

                        $scope.setSelectedItemsBgColor = function () {
                            logger("setSelectedItemsBgColor");

                            $('.asset-card input[type="checkbox"]').each(
                                (index, item) => {
                                    var container;
                                    if ($scope.activeView === "grid") {
                                        container = $(item)
                                            .parent()
                                            .parent()
                                            .parent()
                                            .parent()
                                            .parent()[0];
                                    } else if ($scope.activeView === "list") {
                                        container = $(item)
                                            .parent()
                                            .parent()
                                            .parent()
                                            .parent()[0];
                                    }

                                    if (container) {
                                        if ($(item)[0].checked) {
                                            container.style.backgroundColor =
                                                $scope.cardBgColorOnFocus;
                                        } else {
                                            if (
                                                container.childNodes &&
                                                container.childNodes.length &&
                                                container.childNodes.classList
                                            ) {
                                                if (
                                                    !container.childNodes[0].classList.contains(
                                                        "create-folder"
                                                    )
                                                ) {
                                                    container.style.backgroundColor =
                                                        "#FFFFFF";
                                                }
                                            }
                                        }
                                    }
                                }
                            );
                        };

                        $scope.handleMediaIconKeyDown = function(e) {
                            logger('handleMediaIconKeyDown');

                            if(e.which === 9) {
                                if(!e.shiftKey){
                                    e.preventDefault();
                                    $(e.target).parent().parent().find('div.folder-title').hide();
                                    $(e.target).parent().parent().find('div.folder-title-no-hover').hide();
                                    $(e.target).parent().parent().find('input.asset-title').show();
                                    $(e.target).parent().parent().find('input.asset-title').focus();
                                }else{
                                    $scope.persistTitle({
                                        titleField: $(e.target).parent().parent().find('input.asset-title'),
                                        shouldRefreshContent: true,
                                    });
                                }
                            }
                        }

                        $scope.handleTitleInputKeyDown = function(e) {
                            logger('handleTitleInputKeyDown');
                            if(e.which === 9) {
                                e.preventDefault();

                                if(!e.shiftKey) {
                                    if($scope.activeView === 'grid') {
                                        $scope.persistTitle({
                                            titleField: e.target,
                                            shouldRefreshContent: false,
                                            shouldFocusOnMenuIcon: true,
                                        });
                                    } else {
                                        $scope.persistTitle({
                                            titleField: e.target,
                                            shouldRefreshContent: false,
                                            shouldFocusOnDescription: true,
                                        });
                                    }
                                } else if(e.shiftKey) {
                                    $scope.persistTitle({
                                        titleField: e.target,
                                        shouldRefreshContent: false,
                                        shouldFocusOnAssetTypeIcon: true,
                                    });
                                }
                            }
                        };

                        $scope.handleMenuIconKeyPress = function(e) {
                            logger('handleMenuIconKeyPress');

                            if(e.which === 13 || e.which === 32) {
                                e.preventDefault();
                                var el = e.target;
                                var menu = $(el).parent().children('.menu');
                                if(!$(menu).is(':visible')) {
                                    $('.menu').hide();
                                    $(".menu-icon").attr("aria-expanded","false");
                                    $(menu).show();
                                    $scope.menuDescriptionText = (!$scope.content.description || $scope.content.description.trim() === '') ? 'Add Description' : 'Edit Description';
                                    $(e.target).attr("aria-expanded","true");
                                } else {
                                    $(menu).hide();
                                    $(e.target).attr("aria-expanded","false");
                                }
                                setTimeout(() => {
                                    if($(menu).is(':visible')){
                                        $(menu).find('[tabindex="0"]').first().focus();
                                    }else{
                                        $(e.target).focus();
                                    }
                                }, 100);
                            }
                        };

                        $scope.handleMenuIconKeyDown = function(e) {
                            logger('handleMenuIconKeyDown');

                            if(e.which === 9 && !e.shiftKey) {
                                e.preventDefault();
                                var menuIcon = e.target;
                                var menu = $(menuIcon).parent().children('.menu');

                                if(!$(menu).is(':visible')) {
                                    if($scope.activeView === 'grid') {
                                        $(menuIcon).parent().parent().find('p.description').hide();
                                        $(menuIcon).parent().parent().find('p.description-no-hover').hide();
                                        $(menuIcon).parent().parent().find('p.create-folder-description-placeholder').hide();
                                        $(menuIcon).parent().parent().find('textarea.description').show();
                                        $(menuIcon).parent().parent().find('textarea.description').focus();
                                        $(menuIcon).parent().parent().find('textarea.description').scrollTop(0);
                                    } else if($scope.activeView === 'list') {
                                        $scope.persistTitle({
                                            titleField: $(e.target).parent().find('input.asset-title'),
                                            shouldRefreshContent: true,
                                            focusOnNextCard: true,
                                        });
                                    }
                                } else {
                                    //menu is visible
                                    $(menu).find('[tabindex="0"]').first().focus();
                                }

                            } else if(e.which === 9 && e.shiftKey) {
                                e.preventDefault();
                                if($scope.activeView === 'list') {
                                    $(e.target).parent().parent().find('p.description-no-hover').hide();
                                    $(e.target).parent().parent().find('p.description').hide();
                                    $(e.target).parent().parent().find('textarea.description').show();
                                    $(e.target).parent().parent().find('textarea.description').focus();
                                    $(e.target).parent().parent().find('textarea.description').scrollTop(0);

                                } else if($scope.activeView === 'grid') {
                                    $(e.target).parent().parent().find('div.folder-title').hide();
                                    $(e.target).parent().parent().find('div.folder-title-no-hover').hide();
                                    $(e.target).parent().parent().find('input.asset-title').show();
                                    $(e.target).parent().parent().find('input.asset-title').focus();
                                }
                            }
                        }

                        $scope.handleLastMenuItemKeyDown = function(e) {
                            logger('handleLastMenuItemKeyDown');
                            if(e.which === 9 && !e.shiftKey) {
                                e.preventDefault();
                                $(e.target).parent().parent().parent().children('.moreActionsButton').focus();
                            }
                        }

                        /**
                         * params: {
                         *     titleField,
                         *     shouldRefreshContent,
                         *     shouldFocusOnDescription
                         *     shouldFocusOnMenuIcon
                         *     shouldFocusOnDescription
                         *     shouldFocusOnAssetTypeIcon
                         *     shouldNotChangeFocus
                         *     focusOnNextCard
                         * }
                         * */
                        $scope.persistTitle = function (params) {
                            logger("persistTitle");
                            $scope.isPersistingTitle = true;

                            try {
                                var updatedXid = $(params.titleField)
                                    .parents("[data-xid]")
                                    .attr("data-xid");
                                $scope.updateItem(updatedXid);

                                //TODO: save selected checkboxes
                                saveSelectedCheckboxes();

                                if (params.shouldRefreshContent) {
                                    //It needs to wait for the content to be saved.
                                    setTimeout(function () {
                                        $scope.getCollectionContent(
                                            $scope.pagination.current
                                        );

                                        CollectionService.GetCollectionTree.get(
                                            { cid: $state.params.collectionId },
                                            function (tree) {
                                                generateTreePath(tree);
                                                $scope.collectionTree = tree;
                                                $scope.filteredCollectionTree = tree;
                                                $scope.collectionTree.show = false;
                                                $scope.currentCollection.crumbs =
                                                    generateCrumbs(
                                                        $scope.currentCollection
                                                            .cid,
                                                        $scope.currentCollection
                                                            .path
                                                    );
                                                if (
                                                    $scope.currentCollection
                                                        .pathLength >= 3
                                                ) {
                                                    $(
                                                        ".course-breadcrumb-text"
                                                    ).css({
                                                        width: "auto",
                                                        "max-width": "40%",
                                                    });
                                                } else {
                                                    $(
                                                        ".course-breadcrumb-text"
                                                    ).css({
                                                        width: "auto",
                                                        "max-width": "95%",
                                                    });
                                                }

                                                selectCheckboxes();
                                                $scope.manageCheckAllState();
                                            }
                                        );

                                        $(".assets").children().last().show();

                                        // //TODO: select checkboxes again
                                        // selectCheckboxes();
                                    }, 1000);
                                }
                            } finally {
                                $(params.titleField).hide();
                                $(params.titleField)
                                    .parent()
                                    .find(".folder-title")
                                    .text($(params.titleField).val());
                                $(params.titleField)
                                    .parent()
                                    .find(".folder-title")
                                    .hide();
                                $(params.titleField)
                                    .parent()
                                    .find(".folder-title-no-hover");
                                $(params.titleField)
                                    .parent()
                                    .find(".folder-title-no-hover")
                                    .text($(params.titleField).val());
                                $(params.titleField)
                                    .parent()
                                    .find(".folder-title-no-hover")
                                    .removeClass("ng-hide");
                                $(params.titleField)
                                    .parent()
                                    .find(".folder-title-no-hover")
                                    .show();

                                if (params.shouldFocusOnDescription ) {
                                    $(params.titleField)
                                        .parent()
                                        .parent()
                                        .find(
                                            ".create-folder-description-placeholder"
                                        )
                                        .hide();
                                    $(params.titleField)
                                        .parent()
                                        .parent()
                                        .find("p.description")
                                        .hide();
                                    $(params.titleField)
                                        .parent()
                                        .parent()
                                        .find("p.description-no-hover")
                                        .hide();
                                    $(params.titleField)
                                        .parent()
                                        .parent()
                                        .find("textarea.description")
                                        .show();
                                    $(params.titleField)
                                        .parent()
                                        .parent()
                                        .find("textarea.description")
                                        .focus();
                                }else if(params.shouldFocusOnMenuIcon){
                                        $(params.titleField)
                                    .parent()
                                    .parent()
                                    .find("div.moreActionsButton")
                                    .focus();
                                }else if(params.shouldFocusOnAssetTypeIcon){
                                    $(params.titleField)
                                    .parent()
                                    .parent()
                                    .find("i.asset-type-icon")
                                    .focus();
                                }else if(params.focusOnNextCard){
                                    $scope.focusOnNextCard = true;
                                    var cardList = $("#inlineFolderCreate").parent().find(".asset-card:not(.create-folder)");
                                    if ($scope.activeView === "grid") {
                                        cardList.eq(0).find('.overlayimage[tabindex="0"]').focus();
                                    }else{
                                        cardList.eq(0).find('.card-checkbox[tabindex="0"]').focus();
                                    }
                                }
                            }

                            setTimeout(function () {
                                $scope.isPersistingTitle = false;
                            }, 1000);

                            // trap the return key being pressed
                            return false;
                        };

                        $scope.handleDescriptionTextareaKeyPress = function (
                            e
                        ) {
                            if (e.keyCode === 13) {
                                $scope.persistDescription({
                                    descriptionField: e.target,
                                    shouldRefreshContent: true,
                                });
                            }
                        };

                        $scope.handleDescriptionTextareaKeyDown = function(e) {
                            logger('handleDescriptionTextareaKeyDown')
                            if(e.which === 9 ) {
                                if ($scope.activeView === "grid") {
                                    if(!e.shiftKey){
                                        $scope.persistDescription({
                                            descriptionField: e.target,
                                            shouldRefreshContent: true,
                                            focusOnNextCard: true,
                                        });
                                        e.preventDefault();
                                    }else{
                                        e.preventDefault();
                                        $scope.persistDescription({
                                            descriptionField: e.target,
                                            shouldRefreshContent: false,
                                            shouldFocusOnMenuIcon: true,
                                        });
                                    }
                                }else{
                                   if(!e.shiftKey){
                                        e.preventDefault();
                                        $scope.persistDescription({
                                            descriptionField: e.target,
                                            shouldRefreshContent: false,
                                            shouldFocusOnMenuIcon: true,
                                        });
                                    }else{
                                        e.preventDefault();
                                        $scope.persistDescription({
                                            descriptionField: e.target,
                                            shouldRefreshContent: false,
                                            shouldFocusOnTitle: true,
                                        });
                                    }
                                }
                            }
                        }

                        $scope.isPersistingDescription = false;
                        $scope.persistDescription = function (params) {
                            logger("persistDescription");

                            $scope.isPersistingDescription = true;
                            try {
                                var updatedXid =
                                    params.descriptionField.parentElement.parentElement.parentElement.parentElement.getAttribute(
                                        "data-xid"
                                    );
                                $scope.updateItem(updatedXid);
                                if (params.shouldRefreshContent) {
                                    setTimeout(function () {
                                        $scope.getCollectionContent(
                                            $scope.pagination.current
                                        );

                                        CollectionService.GetCollectionTree.get(
                                            { cid: $state.params.collectionId },
                                            function (tree) {
                                                generateTreePath(tree);
                                                $scope.collectionTree = tree;
                                                $scope.filteredCollectionTree = tree;
                                                $scope.collectionTree.show = false;
                                                $scope.currentCollection.crumbs =
                                                    generateCrumbs(
                                                        $scope.currentCollection
                                                            .cid,
                                                        $scope.currentCollection
                                                            .path
                                                    );
                                                if (
                                                    $scope.currentCollection
                                                        .pathLength >= 3
                                                ) {
                                                    $(
                                                        ".course-breadcrumb-text"
                                                    ).css({
                                                        width: "auto",
                                                        "max-width": "40%",
                                                    });
                                                } else {
                                                    $(
                                                        ".course-breadcrumb-text"
                                                    ).css({
                                                        width: "auto",
                                                        "max-width": "95%",
                                                    });
                                                }
                                            }
                                        );

                                        $(".assets").children().last().show();
                                    }, 500);
                                }
                            } finally {
                                var descriptionText =
                                    params.descriptionField.parentElement.querySelector(
                                        "p.description"
                                    );
                                var descriptionNoHoverText =
                                    params.descriptionField.parentElement.querySelector(
                                        "p.description-no-hover"
                                    );
                                var descriptionPlaceHolder =
                                    params.descriptionField.parentElement.querySelector(
                                        "p.create-folder-description-placeholder"
                                    );
                                var descriptionViewValue = "Enter a description";
                                if(params.descriptionField.value.length){
                                    descriptionViewValue = params.descriptionField.value;
                                }
                                //fill p hover
                                descriptionText.innerText = descriptionViewValue;

                                //fill p no hover
                                descriptionNoHoverText.innerText = descriptionViewValue;

                                //hide description hover
                                descriptionText.style.display = "none";

                                //hide description textarea
                                params.descriptionField.style.display = "none";
                                params.descriptionField.style.background = "#FFFFFF";
                                if(!params.descriptionField.value){
                                    descriptionPlaceHolder.style.display = "block";
                                }else{
                                    //display description no hover
                                    descriptionNoHoverText.classList.remove(
                                        "ng-hide"
                                    );
                                    descriptionNoHoverText.style.display = "";
                                }

                                if(params.shouldFocusOnMenuIcon){
                                    var moreActionsButton = $(params.descriptionField).parent().parent().find("div.moreActionsButton");
                                    moreActionsButton.focus();
                                }else if(params.shouldFocusOnTitle){
                                    $(params.descriptionField).parent().parent().find("div.asset-title").hide();
                                    var assetTitle = $(params.descriptionField).parent().parent().find("input.asset-title");
                                    assetTitle.show();
                                    assetTitle.focus();
                                }else if(params.focusOnNextCard){
                                    $scope.focusOnNextCard = true;
                                    var cardList = $("#inlineFolderCreate").parent().find(".asset-card:not(.create-folder)");
                                    if ($scope.activeView === "grid") {
                                        cardList.eq(0).find('.asset-image[tabindex="0"]').focus();
                                    }else{
                                        cardList.eq(0).find('.card-checkbox[tabindex="0"]').focus();
                                    }
                                }
                            }

                            setTimeout(function () {
                                $scope.isPersistingDescription = false;
                            }, 1000);
                        };

                        $("#folderDescriptionPGrid").blur(function (e) {
                            logger("folderDescriptionPGrid blur");
                            // trap the return key being pressed
                            var updatedXid = $(this)
                                .parent()
                                .parent()
                                .data("xid");
                            $scope.updateItem(updatedXid);
                            return false;
                        });

                        $("div[contenteditable]").keydown(function (e) {
                            // trap the return key being pressed
                            if (e.keyCode === 13 || e.keyCode === 9) {
                                $("div[contenteditable]").blur("test");
                                var updatedXid = $(this)
                                    .parent()
                                    .parent()
                                    .parent()
                                    .data("xid");
                                $scope.updateItem(updatedXid);
                                return false;
                            }
                        });

                        $("p[contenteditable]").keydown(function (e) {
                            // trap the return key being pressed
                            if (e.keyCode === 13 || e.keyCode === 9) {
                                $("p[contenteditable]").blur();
                                var updatedXid = $(this)
                                    .parent()
                                    .parent()
                                    .data("xid");
                                $scope.updateItem(updatedXid);
                                return false;
                            }
                        });

                        $scope.openModal = function (type) {
                            logger("openModal");
                            $timeout(function() {
                                $("#cbMakeQuizAvailable").prop('checked', false);
                            }, 100);
                            var xids = [];
                            var contents = $scope.currentCollection.contents;
                            if ($scope.showSearchResults) {
                                contents = [];
                                $.each(
                                    $scope.searchResults.hits,
                                    function (h, j) {
                                        $.each(
                                            $(".item-checkbox:checked"),
                                            function (k, v) {
                                                var cid = $(v)
                                                    .data("cid");
                                                if (cid === j.parent.cid) {
                                                    xids.push(
                                                        $(v)
                                                            .data("xid")
                                                    );
                                                    contents.push(...j.hits);
                                                }
                                            }
                                        );
                                    }
                                );
                            } else {
                                if ($scope.activeView === "list") {
                                    $.each(
                                        $(".item-checkbox:checked"),
                                        function (k, v) {
                                            console.log($(v));
                                            xids.push(
                                                $(v)
                                                    .data("xid")
                                            );
                                        }
                                    );
                                } else {
                                    $.each(
                                        $(".item-checkbox:checked"),
                                        function (k, v) {
                                            console.log($(v));
                                            xids.push(
                                                $(v)
                                                    .data("xid")
                                            );
                                        }
                                    );
                                }
                            }

                            var filteredArray = contents.filter((el) => {
                                return xids.some((f) => {
                                    return f === el.xid;
                                });
                            });
                            console.log("filtered items: ", filteredArray);
                            $scope.content = {
                                type: type,
                                item: filteredArray,
                            };
                            $("#itemManagementWindow")
                                .modal("show")
                                .on("shown.bs.modal", function () {
                                    modalFocus(
                                        "#publishHeading",
                                        "#returnTopublishHeading"
                                    );
                                    $("#returnTopublishHeading").on(
                                        "focus",
                                        function () {
                                            $("#publishHeading").focus();
                                        }
                                    );
                                });
                        };

                        $scope.handlePnpTabClick = function (e, tab) {
                            logger("handlePnpTabClick");

                            //remove all activeitem classes and update all aria-selected and tabindex
                            $(e.target).parents("[role='tablist']").find("[role='tab']").removeClass('activeitem').attr("aria-selected",false).attr("tabindex","-1");

                            //add activeitem class to relative and update aria-selected and tabindex
                            if($(e.target).attr("role") && $(e.target).attr("role")==="tab"){
                                $(e.target).addClass('activeitem').attr("aria-selected","true").attr("tabindex","0");
                            }else{
                                $(e.target).parents("[role='tab']").addClass('activeitem').attr("aria-selected","true").attr("tabindex","0");
                            }

                            //remove all navbar-icon active
                            $(e.target).parents("[role='tablist']").find('.navbar-icon').removeClass('active');

                            //add navbar-icon active
                            $(e.target).find('.navbar-icon').addClass('active');

                            if(tab === 'pnp') {
                                $scope.search.activateSearch = true;
                                $scope.toggleSearch(false);
                                $scope.unpublished = false;
                                $scope.getParent($state.params.collectionId);
                            }

                            if(tab === 'unpublished') {
                                $scope.search.activateSearch = true;
                                $scope.toggleSearch(false);
                                $scope.unpublished = true;
                                $scope.activeLink = 'unpublished';
                                $scope.getParent($state.params.collectionId);
                            }

                            if (tab === 'mediainbox') {
                                $scope.loadComponent('mediainbox');
                            }

                            if (tab === 'scheduler') {
                                $scope.loadComponent('scheduler');
                            }
                        };

                        $scope.checkForEnterKey = function (event, action) {
                            logger("checkForEnterKey");

                            if (event.keyCode === 13 || event.keyCode === 32) {
                                switch (action) {
                                    case "search":
                                        $scope.findContent();
                                        break;
                                    case "collectionTree":
                                        $("#folder-popover-trigger").popover(
                                            "toggle"
                                        );
                                        $(".folder-popover").css("left", 0);
                                        $(".folder-popover .arrow").css(
                                            "left",
                                            "58px"
                                        );
                                        break;
                                    case "settingsLaunch":
                                        $scope.loadComponent("settings");
                                        break;
                                    case "pnpLaunch":
                                        $(event.target).click();
                                        break;
                                    case "unpublishedLaunch":
                                        $(event.target).click();
                                        break;
                                    case "mediaInboxLaunch":
                                        $(event.target).click();
                                        break;
                                    case "zoomImportLaunch":
                                        $scope.loadComponent("zoomimport");
                                        break;
                                    case "zoomRecordingLaunch":
                                        $scope.loadComponent("zoomrecording");
                                        break;
                                    case "schedulerLaunch":
                                        $(event.target).click();
                                        break;
                                    case "resetFilterAndSort":
                                        $scope.resetFilterAndSort();
                                        break;
                                    case "applyFilterAndSort":
                                        $scope.applyFilterAndSort();
                                }
                            }
                        };

                        $scope.checkKeyDown = function (e) {
                            var tgt = e.currentTarget, flag = false;

                            switch (e.key) {
                                case 'ArrowLeft':
                                  $scope.initializeTabs();
                                  $scope.moveFocusToPreviousTab(tgt);
                                  flag = true;
                                  break;

                                case 'ArrowRight':
                                  $scope.initializeTabs();
                                  $scope.moveFocusToNextTab(tgt);
                                  flag = true;
                                  break;

                                case 'Home':
                                  $scope.initializeTabs();
                                  $scope.moveFocusToTab($scope.firstTab);
                                  flag = true;
                                  break;

                                case 'End':
                                  $scope.initializeTabs();
                                  $scope.moveFocusToTab($scope.lastTab);
                                  flag = true;
                                  break;

                                default:
                                  break;
                            }

                            if (flag) {
                                e.stopPropagation();
                                e.preventDefault();
                            }
                        };
                        $scope.moveFocusToTab = function(currentTab){
                            if (currentTab) {
                                if(typeof currentTab.focus === 'function'){
                                    currentTab.focus();
                                    //Include fallowing line for automatic tab selection
                                    //currentTab.click();
                                }else{
                                    console.log("moveFocusToTab() Element is not focusable.");
                                }
                            } else {
                                console.log("moveFocusToTab() Element to focus is not found.");
                            }
                        };
                        $scope.moveFocusToPreviousTab = function(currentTab){
                            var index;

                            if (currentTab === $scope.firstTab) {
                                $scope.moveFocusToTab($scope.lastTab);
                            } else {
                                index = $scope.tabs.indexOf(currentTab);
                                $scope.moveFocusToTab($scope.tabs[index - 1]);
                            }

                        };
                        $scope.moveFocusToNextTab = function(currentTab){
                            var index;

                            if (currentTab === $scope.lastTab) {
                                $scope.moveFocusToTab($scope.firstTab);
                            } else {
                                index = $scope.tabs.indexOf(currentTab);
                                $scope.moveFocusToTab($scope.tabs[index + 1]);
                            }
                        };
                        $scope.initializeTabs = function () {
                            $scope.tabs = Array.from($('.navbarContentPnp [role=tab]:visible'));
                            $scope.firstTab = null;
                            $scope.lastTab = null;
                            for (var i = 0; i < $scope.tabs.length; i++) {
                                if (!$scope.firstTab) {
                                    $scope.firstTab = $scope.tabs[i];
                                }
                                $scope.lastTab = $scope.tabs[i];
                            }
                            if(!$scope.firstTab || !$scope.lastTab){
                                console.log("initializeTabs failed and are empty");
                            }else if(typeof $scope.firstTab.focus !== 'function' || typeof $scope.lastTab.focus !== 'function'){
                                console.log("initializeTabs failed and have no focus function");
                            }
                        };

                        $scope.loadComponent = function (component) {
                            logger("loadComponent");

                            if (component !== $scope.activeLink) {
                                $(".empty-wrapper").show();
                                $scope.activeLink = component;
                            }
                        };

                        $scope.handleUploadMenuClick = function(e){
                            var uploadButton = $(e.target).parents(".dropdown").find(".dropdown-toggle");
                            if(!uploadButton.is(".open")){
                                uploadButton.addClass("open").attr("aria-expanded","true");
                                uploadButton.find('+ .dropdown-menu [tabindex="0"]').first().focus();
                            }else{
                                uploadButton.removeClass("open").attr("aria-expanded","false");
                            }
                        };

                        $scope.handleUploadMenuKeydown = function(e){
                            if(e.which===32 || e.which===13){
                                e.preventDefault();
                                $(e.target).click();
                            } else if (e.which === 9 && !e.shiftKey) {
                                var lastItem = $(e.target).parents(".dropdown").find('.dropdown-menu [tabindex="0"]').last();
                                if($(e.target).is(lastItem)){
                                    e.preventDefault();
                                    $(e.target).parents(".dropdown").find('.dropdown-toggle').focus();
                                }
                            } else if(e.which===27){
                                $(e.target).parents(".dropdown").find(".dropdown-toggle").removeClass("open").attr("aria-expanded","false").focus();
                            }
                        };

                        $scope.hideUploadMenuWhenClickOutside = function(e){
                            if(!$(e.target).is(".dropdown-toggle") &&
                                    $(e.target).parents(".dropdown-toggle").length===0){
                                $(".dropdown-toggle").removeClass("open").attr("aria-expanded","false");
                            }
                        };

                        function getParameterByName(name, url) {
                            if (!url) url = window.location.href;
                            name = name.replace(/[\[\]]/g, "\\$&");
                            var regex = new RegExp(
                                    "[?&]" + name + "(=([^&#]*)|&|#|$)"
                                ),
                                results = regex.exec(url);
                            if (!results) return null;
                            if (!results[2]) return "";
                            return decodeURIComponent(
                                results[2].replace(/\+/g, " ")
                            );
                        }

                        var atmosphereSetup = function () {
                            logger("atmosphereSetup");
                            if(!$scope.account) {
                                return;
                            }
                            var request = {
                                url:
                                    "./notification/inbox/" +
                                    $state.params.collectionId,
                                contentType: "application/json",
                                logLevel: "debug",
                                transport: "websocket",
                                fallbackTransport: "streaming",
                                trackMessageLength: true,
                                reconnectInterval: 5000,
                                enableXDR: true,
                                timeout: 300000,
                                shared: true,
                            };

                            request.onOpen = function (response) {
                                console.log(
                                    "Atmosphere connected using " +
                                        response.transport
                                );
                            };

                            request.onMessage = function (response) {
                                try {
                                    var message = JSON.parse(
                                        response.responseBody
                                    );
                                    if (
                                        message.parentCollectionId ===
                                            $state.params.collectionId &&
                                        message.newSubmissions
                                    ) {
                                        $scope.submissions.new =
                                            message.newSubmissions;
                                    }
                                } catch (err) {
                                    console.log(err.message);
                                }
                            };

                            request.onClientTimeout = function (response) {
                                setTimeout(function () {
                                    atmosphereService.subscribe(request);
                                }, request.reconnectInterval);
                            };

                            atmosphereService.subscribe(request);

                            isAtmosphereSetup = true;
                        };
                    }

                    $scope.$on("$stateChangeStart", function (event) {
                        $("body").off("click");
                    });

                    $scope.menuMove = function (e) {
                        logger("menuMove");
                        //select item's checkbox
                        var el = e.target;
                        var checkbox =
                            el.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector(
                                "input[type=checkbox]"
                            );
                        checkbox.checked = true;

                        var menu = $scope.getMenuLocationFromMenuItem(el);
                        menu.style.display = "none";

                        //open modal to move
                        $scope.openModal("Move");
                    };

                    $scope.getMenuLocationFromMenuItem = function (el) {
                        logger("getMenuLocationFromMenuItem");
                        var locations = [
                            { nodeName: "LI", level: 2 },
                            { nodeName: "IMG", level: 5 },
                            { nodeName: "DIV", level: 3 },
                            { nodeName: "SPAN", level: 4 },
                        ];

                        var lookupLevel = locations.find(
                            (p) => p.nodeName === el.nodeName
                        );

                        if (lookupLevel) {
                            while (lookupLevel.level > 0) {
                                if (el.parentElement) {
                                    el = el.parentElement;
                                } else {
                                    break;
                                }
                                lookupLevel.level--;
                            }

                            return el;
                        }

                        return el;
                    };

                    $scope.menuCopy = function (e) {
                        logger("menuCopy");
                        var el = e.target;
                        //select item's checkbox
                        var checkbox =
                            el.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector(
                                "input[type=checkbox]"
                            );
                        checkbox.checked = true;

                        var menu = $scope.getMenuLocationFromMenuItem(el);
                        menu.style.display = "none";

                        //open modal to copy
                        $scope.openModal("Copy");
                    };

                    $scope.menuDelete = function (e) {
                        logger("menuDelete");
                        var el = e.target;
                        var checkbox =
                            el.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector(
                                "input[type=checkbox]"
                            );
                        checkbox.checked = true;

                        var menu = $scope.getMenuLocationFromMenuItem(el);
                        menu.style.display = "none";

                        $scope.deleteItem();
                    };

                    $scope.hideTitleField = function (e) {
                        logger("hideTitleField");
                        var el = e.target;
                        var titleField = el;
                        var titleValue = el.value;

                        //fill title text div
                        var titleText =
                            el.parentElement.querySelector("div.folder-title");
                        titleText.innerText = titleValue;

                        titleField.style.background = "#FFFFFF";
                        if (titleValue.length) {
                            //hide input title
                            titleField.style.display = "none";

                            //display title text div hover
                            if ($scope.isPersistingTitle === false) {
                                titleText.classList.remove("ng-hide");
                                titleText.style.display = "";
                            }
                        }
                    };

                    $scope.handleDescriptionTextareaMouseLeave = function (e) {
                        logger("handleDescriptionTextareaMouseLeave");
                        var focusedElement = document.activeElement;

                        if (focusedElement !== e.target) {
                            $(e.target).hide();

                            if (
                                e.target.value.length &&
                                e.target.value !== "Enter a description"
                            ) {
                                $(e.target)
                                    .parent()
                                    .children("p.description")
                                    .val(e.target.value);
                                $(e.target)
                                    .parent()
                                    .children("p.description-no-hover")
                                    .hide();
                                $(e.target)
                                    .parent()
                                    .children(
                                        "p.create-folder-description-placeholder"
                                    )
                                    .hide();
                                $(e.target)
                                    .parent()
                                    .children("p.description-no-hover")
                                    .val(e.target.value);
                                $(e.target)
                                    .parent()
                                    .children("p.description")
                                    .show();
                            } else {
                                $(e.target)
                                    .parent()
                                    .children(
                                        "p.create-folder-description-placeholder"
                                    )
                                    .show();
                            }
                        }
                    };

                    $scope.hideDescriptionField = function (e) {
                        logger("hideDescriptionField");
                        var el = e.target;
                        var descriptionText =
                            el.parentElement.querySelector("p.description");
                        var descriptionTextNoHover =
                            el.parentElement.querySelector(
                                "p.description-no-hover"
                            );

                        //hide textarea
                        el.style.display = "none";
                        el.style.background = "#FFFFFF";

                        if ($scope.isPersistingDescription === true) {
                            //hide hover
                            descriptionText.style.display = "none";

                            //display description no hover
                            descriptionTextNoHover.classList.remove("ng-hide");
                            descriptionTextNoHover.style.display = "";
                        } else {
                            //hide no hover
                            descriptionTextNoHover.style.display = "none";

                            //show hover
                            var descriptionValue = el.value;
                            if (descriptionValue.trim() === "") {
                                descriptionText.innerHTML =
                                    "Enter a description";
                            } else {
                                descriptionText.innerHTML = descriptionValue;
                            }
                            descriptionText.classList.remove("ng-hide");
                            descriptionText.style.display = "";
                        }
                    };

                    $scope.showMenu = function (e) {
                        logger("showMenu");
                        var titleField;
                        if (
                            $("input.create-folder-title-grid").length
                        ) {
                            titleField = $(
                                "input.create-folder-title-grid"
                            )[0];
                        } else if (
                            $("input.create-folder-title-list").length
                        ) {
                            titleField = $(
                                "input.create-folder-title-list"
                            )[0];
                        }
                        $scope.persistTitle({
                            titleField: titleField,
                            shouldRefreshContent: false,
                            shouldNotChangeFocus: true,
                        });

                        var menu = $(e.target)
                            .parents("div[data-xid]")
                            .find(".menu");
                        var isMenuVisible = $(menu).is(":visible");

                        //hide all menus
                        $(".menu").hide();

                        //set menu icon aria-expanded to false
                        $(".menu-icon").attr("aria-expanded","false");

                        $(e.target)
                            .parents("div[data-xid]")
                            .find("textarea.description")
                            .hide();
                        var descriptionValue = $(e.target)
                            .parents("div[data-xid]")
                            .find("textarea.description")
                            .val();
                        descriptionValue = descriptionValue.length
                            ? descriptionValue
                            : "Enter a description";
                        $(e.target)
                            .parents("div[data-xid]")
                            .find("p.description-no-hover")
                            .hide();
                        $(e.target)
                            .parents("div[data-xid]")
                            .find("p.description-no-hover")
                            .text(descriptionValue);
                        $(e.target)
                            .parents("div[data-xid]")
                            .find("p.create-folder-description-placeholder")
                            .hide();
                        $(e.target)
                            .parents("div[data-xid]")
                            .find("p.description")
                            .text(descriptionValue);
                        $(e.target)
                            .parents("div[data-xid]")
                            .find("p.description")
                            .show();

                        if (menu) {
                            if (!isMenuVisible) {
                                $(menu).show();
                                $(menu).attr("visible", "true");
                            }
                        }
                    };

                    $scope.hideBreadcrumbMenuWhenClickOutside = function(e){
                        if(!$(e.target).hasClass("breadcrumb-menu") &&
                            $(e.target).parents(".breadcrumb-menu").length ===0 &&
                            !$(e.target).hasClass("ellipsis") &&
                            $(e.target).parents(".ellipsis").length === 0){
                            if($(".breadcrumb-menu").is(":visible")){
                                $(".breadcrumb-menu:visible").parents('.breadcrumb').find(".ellipsis").first().attr("aria-expanded",false);
                                $('.breadcrumb-menu').hide();
                            }
                        }
                    };

                    $scope.persistCreateFolderContent = function (e) {
                        logger("persistCreateFolderContent");
                        if ($("#inlineFolderCreate").is(":visible")) {
                            //Will not consider:
                            //- Switch View buttons (grid and list views)
                            //- Checkbox of Create Folder card
                            if (
                                e.target.id !== "grid" &&
                                e.target.id !== "list" &&
                                !$(e.target).hasClass("moreActionsButton") &&
                                !$(e.target).parent().hasClass("moreActionsButton") &&
                                !$(e.target)
                                    .parents(".create-folder")
                                    .find("input")
                                    .hasClass("new-folder-checkbox")

                            ) {
                                var titleField;
                                if (
                                    $("input.create-folder-title-grid").length
                                ) {
                                    titleField = $(
                                        "input.create-folder-title-grid"
                                    )[0];
                                } else if (
                                    $("input.create-folder-title-list").length
                                ) {
                                    titleField = $(
                                        "input.create-folder-title-list"
                                    )[0];
                                }

                                $scope.persistTitle({
                                    titleField: titleField,
                                    shouldRefreshContent: false,
                                });

                                var descriptionField;
                                if (
                                    $("textarea.create-folder-description-grid").length
                                ) {
                                    descriptionField = $(
                                        "textarea.create-folder-description-grid"
                                    )[0];
                                } else if (
                                    $("textarea.create-folder-description-list").length
                                ) {
                                    descriptionField = $(
                                        "textarea.create-folder-description-list"
                                    )[0];
                                }
                                $scope.persistDescription({
                                    descriptionField: descriptionField,
                                    shouldRefreshContent: true,
                                });

                                // var isDoubleCreateFolder = false;
                                // if($(e.target).parent().hasClass('create-folder-button') ||
                                //     $(e.target).hasClass('create-folder-button')) {
                                //     isDoubleCreateFolder = true;
                                // }
                                //
                                // $scope.persistTitle({
                                //     titleField,
                                //     shouldRefreshContent: true,
                                //     shouldFocusOnDescription: false,
                                //     isDoubleCreateFolder
                                // });
                            }
                        }
                    };

                    $scope.clickHistory = [];

                    $scope.persistTitleCreateFolderClickOutside = function (e) {
                        logger("persistTitleCreateFolderClickOutside");
                        if (
                            $scope.lastFocusedCFTitle &&
                            $scope.lastFocusedCFTitle.nodeName === "INPUT" &&
                            ($scope.lastFocusedCFTitle.classList.contains(
                                "create-folder-title-grid"
                            ) ||
                                $scope.lastFocusedCFTitle.classList.contains(
                                    "create-folder-title-list"
                                ))
                        ) {
                            var inputTitle;
                            var titleSelector;
                            if (
                                $scope.lastFocusedCFTitle.classList.contains(
                                    "create-folder-title-grid"
                                )
                            ) {
                                titleSelector = ".create-folder-title-grid";
                                inputTitle =
                                    document.querySelector(titleSelector);
                            }

                            if (
                                $scope.lastFocusedCFTitle.classList.contains(
                                    "create-folder-title-list"
                                )
                            ) {
                                titleSelector = ".create-folder-title-list";
                                inputTitle =
                                    document.querySelector(titleSelector);
                            }

                            $(titleSelector).hide();
                            $(titleSelector)
                                .parent()
                                .children("div.folder-title-no-hover")
                                .hide();
                            $(titleSelector)
                                .parent()
                                .children("div.folder-title")
                                .show();
                            $(titleSelector)
                                .parent()
                                .parent()
                                .find("p.description")
                                .hide();
                            $(titleSelector)
                                .parent()
                                .parent()
                                .find("p.description-no-hover")
                                .hide();
                            $(titleSelector)
                                .parent()
                                .parent()
                                .find("p.create-folder-description-placeholder")
                                .hide();
                            $(titleSelector)
                                .parent()
                                .parent()
                                .find("textarea.description")
                                .show();
                            $(titleSelector)
                                .parent()
                                .parent()
                                .find("textarea.description")
                                .focus();

                            $scope.persistTitle({
                                titleField: inputTitle,
                                shouldFocusOnDescription: true,
                            });

                            $scope.lastFocusedCFTitle = null;
                        }
                    };

                    $scope.hideBreadcrumbTreeViewWhenClickOutside = function(e) {
                        logger('hideBreadcrumbTreeViewWhenClickOutside');
                        var isTreeView = $(e.target).parents('.collection-tree').length > 0;
                        var isDropDown = $(e.target).parents('.down-arrow').length > 0 || $(e.target).hasClass('down-arrow');
                        var isBreadcrumbRoot = $(e.target).parents('.breadcrumb').find('.root-container').length > 0

                        $timeout(function () {
                            if(!isTreeView && !isDropDown && !isBreadcrumbRoot) {
                                $scope.showCollectionTree = false;
                            }
                        });
                    }

                    $scope.hideMenuWhenClickOutside = function (e) {
                        logger("hideMenuWhenClickOutside");

                        //hide menu when clicking outside menu
                        //is the clicked element part of menu?
                        var menuCandidate = $scope.getMenuLocationFromMenuItem(e.target);
                        var isMenu = menuCandidate.classList.contains("menu");

                        //or is it the menu icon?
                        var menuIconCandidate = $scope.getMenuIconLocation(e.target);
                        var isMenuIcon = null;
                        if(menuIconCandidate){
                            isMenuIcon = menuIconCandidate.classList.contains("menu-item-container");
                        }

                        if (!isMenu && !isMenuIcon) {
                            $(".menu").hide();
                            //set menu icon aria-expanded to false
                            $(".menu-icon").attr("aria-expanded","false");
                            $(".menu").attr("visible", "false");
                        }
                    };

                    $scope.getMenuIconLocation = function (el) {
                        logger("getMenuIconLocation");
                        var locationsMap = [
                            {
                                nodeName: "IMG",
                                location: el.parentElement.parentElement,
                            },
                            { nodeName: "I", location: el.parentElement },
                            { nodeName: "DIV", location: el },
                            { nodeName: "SPAN", location: el.previousElementSibling },
                            { nodeName: "INPUT", location: el },
                        ];

                        var searchedElement = locationsMap.find(
                            (p) => p.nodeName === el.nodeName
                        );

                        if (searchedElement) {
                            return searchedElement.location;
                        }

                        return el;
                    };

                    $scope.handleDescriptionMouseOver = function (e) {
                        logger("handleDescriptionMouseOver");

                        var titleValue = $(e.target)
                            .parent()
                            .parent()
                            .find("input.folder-title")
                            .val();

                        if (titleValue.length) {
                            $(e.target).hide();
                            $(e.target)
                                .parent()
                                .children("textarea.description")
                                .show();
                        }
                    };

                    $scope.hideMenu = function (e) {
                        logger("hideMenu");
                        var el = e.target;
                        if (el.classList.contains("menu")) {
                            el.style.display = "none";
                            return;
                        }

                        var menu = el.querySelector(".menu");
                        if (menu) menu.style.display = "none";
                    };

                    $scope.menuRename = function (e) {
                        logger("menuRename");
                        var el = e.target;

                        //Name input text field
                        var itemNameField =
                            el.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector(
                                "input[type=text]"
                            );

                        //Name text with hover
                        var itemNameText =
                            itemNameField.parentElement.querySelector(
                                "div.folder-title"
                            );

                        //Name text no hover
                        var itemNameTextNoHover =
                            itemNameField.parentElement.querySelector(
                                "div.folder-title-no-hover"
                            );

                        var menu = $scope.getMenuLocationFromMenuItem(el);

                        var descriptionNoHover =
                            menu.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector(
                                "p.description-no-hover"
                            );
                        var descriptionText =
                            menu.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector(
                                "p.description"
                            );
                        var descriptionPlaceholder =
                            menu.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector(
                                "p.create-folder-description-placeholder"
                            );
                        var descriptionField =
                            menu.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector(
                                "textarea"
                            );

                        if ($scope.activeView === "grid") {
                            //Hide Description with hover
                            descriptionText.style.display = "none";

                            //Hide Description placeholder
                            descriptionPlaceholder.style.display = "none";

                            //hide Description textarea
                            descriptionField.style.display = "none";

                            //Show Description text no hover
                            descriptionNoHover.style.display = "";
                            var descriptionValue = descriptionField.value;
                            if (descriptionValue.trim() === "") {
                                descriptionNoHover.innerHTML =
                                    "Enter a description";
                                descriptionText.innerHTML =
                                    "Enter a description";
                            }
                        } else if ($scope.activeView === "list") {
                        }

                        //Hide menu
                        menu.style.display = "none";

                        //Hide name with hover
                        itemNameText.style.display = "none";

                        //Hide name no hover
                        itemNameTextNoHover.style.display = "none";

                        //Show name input
                        itemNameField.style.display = "";
                        itemNameField.focus();
                        itemNameField.setSelectionRange(0, 0);
                    };

                    $scope.handleDescriptionNoHoverMouseLeave = function (e) {
                        logger("handleDescriptionNoHoverMouseLeave");
                        $scope.makeDescriptionEditable(e);
                    };

                    $scope.makeDescriptionEditable = function (e) {
                        logger("makeDescriptionEditable");
                        if ($scope.isPersistingTitle === false) {
                            if (
                                $(e.target)
                                    .parent()
                                    .parent()
                                    .find("p.description")
                                    .val().length > 0
                            ) {
                                $(e.target)
                                    .parent()
                                    .parent()
                                    .find(
                                        ".create-folder-description-placeholder"
                                    )
                                    .hide();
                                $(e.target)
                                    .parent()
                                    .parent()
                                    .find("p.description-no-hover")
                                    .hide();
                                $(e.target)
                                    .parent()
                                    .parent()
                                    .find("p.description")
                                    .show();
                            }
                        }
                    };

                    $scope.makeTitleEditable = function (e) {
                        logger("makeTitleEditable");
                        var titleNoHover = e.target;
                        var titleHover =
                            titleNoHover.parentElement.querySelector(
                                "div.folder-title"
                            );

                        //hide title no hover
                        titleNoHover.style.display = "none";

                        //display title hover
                        titleHover.innerHTML = titleNoHover.innerHTML;
                        titleHover.classList.remove("ng-hide");
                        titleHover.style.display = "";
                    };

                    $scope.menuAddDescription = function (e) {
                        logger("menuAddDescription");
                        var el = e.target;

                        var itemDescriptionField =
                            el.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector(
                                "textarea"
                            );
                        var itemDescriptionText =
                            itemDescriptionField.parentElement.querySelector(
                                "p.description"
                            );
                        var itemDescriptionPlaceholder =
                            itemDescriptionField.parentElement.querySelector(
                                ".create-folder-description-placeholder"
                            );
                        var menu = $scope.getMenuLocationFromMenuItem(el);
                        var titleField =
                            menu.parentElement.querySelector(
                                "input.folder-title"
                            );
                        var titleText =
                            menu.parentElement.querySelector(
                                "div.folder-title"
                            );

                        //hide menu
                        menu.style.display = "none";

                        //hide description text
                        itemDescriptionText.style.display = "none";

                        //show textarea
                        itemDescriptionField.style.display = "block";

                        //hide description placeholder
                        itemDescriptionPlaceholder.style.display = "none";

                        //focus on textarea
                        itemDescriptionField.focus();
                        itemDescriptionField.setSelectionRange(0, 0);
                    };

                    $scope.calculateRowsForTextArea = function (e) {
                        logger("calculateRowsForTextArea");
                        var el = e.target;
                        var cols = el.getAttribute("cols");
                        var textLength = el.value.length;
                        var rows = Math.ceil(textLength / cols);

                        if (rows < 1) rows = 1;
                        if (rows > 2) rows = 2;

                        el.setAttribute("rows", rows < 1 ? 1 : rows);
                    };

                    $scope.setCarrotPosition = function (e) {
                        logger("setCarrotPosition");
                        var el = e.target;
                        if (el.createTextRange) {
                            var range = el.createTextRange();
                            range.move("character", 0);
                            range.select();
                        } else {
                            if (el.selectionStart) {
                                el.focus();
                                el.setSelectionRange(0, 0);
                            } else el.focus();
                        }
                    };

                    $scope.showTitleField = function (e) {
                        logger("showTitleField");
                        var el = e.target;
                        var titleField =
                            el.parentElement.querySelector("input");
                        el.style.display = "none";
                        titleField.style.display = "block";
                        titleField.value = el.innerText.trim();
                        titleField.scrollLeft = 0;
                    };

                    $scope.selectAllClick = function (e) {
                        logger("selectAllClick");
                        if($(e.target).attr("aria-disabled")==="true"){
                            return
                        }
                        var el = $(e.target);
                        var checked = el.attr("aria-checked")!=="true";
                        el.attr("aria-checked", checked);
                        var bgcolor = checked ? $scope.cardBgColorOnFocus : "#FFFFFF";

                        $(".asset-card:not(.create-folder)").each(function (
                            index,
                            item
                        ) {
                            $(item).css("background", bgcolor);
                        });

                        $(".button-container .btn-link-secondary").attr(
                            "disabled",
                            !checked
                        );
                        $(".card-checkbox input").prop(
                            "checked",
                            checked
                        );

                        $scope.manageCheckAllState();
                    };

                    $scope.handleSelectAllKeyPress = function (e) {
                        logger("handleSelectAllKeyPress");
                        if($(e.target).attr("aria-disabled")==="true"){
                            return
                        }
                        if (e.which === 13 || e.which === 32) {
                            e.preventDefault();
                            $(e.target).click();
                        }
                    };

                    $scope.handleInputTitleMouseLeave = function (e) {
                        logger("handleInputTitleMouseLeave");
                        $scope.hideInputTitle(e);
                    };

                    $scope.hideInputTitle = function (e) {
                        logger("hideInputTitle");
                        var focusedElement = document.activeElement;

                        if (
                            focusedElement &&
                            focusedElement.nodeName === "TEXTAREA" &&
                            (focusedElement.classList.contains(
                                "create-folder-description-grid"
                            ) ||
                                focusedElement.classList.contains(
                                    "create-folder-description-list"
                                ))
                        ) {
                            $(e.target).hide();
                            $(e.target)
                                .parent()
                                .children("div.folder-title-no-hover")
                                .hide();
                            $(e.target)
                                .parent()
                                .children("div.folder-title")
                                .show();
                        }
                    };

                    $scope.handleInputTitleFocus = function (e) {
                        logger("handleInputTitleFocus");
                        $scope.lastFocusedCFTitle = e.target;

                        if (
                            $(e.target)
                                .parent()
                                .parent()
                                .find("p.description")
                                .text().trim().length
                        ) {
                            $(e.target)
                                .parent()
                                .parent()
                                .find("textarea.description")
                                .hide();
                            $(e.target)
                                .parent()
                                .parent()
                                .find("p.description-no-hover")
                                .hide();
                            $(e.target)
                                .parent()
                                .parent()
                                .find("p.create-folder-description-placeholder")
                                .hide();
                            $(e.target)
                                .parent()
                                .parent()
                                .find("p.description")
                                .show();
                        } else {
                            $(e.target)
                                .parent()
                                .parent()
                                .find("textarea.description")
                                .hide();
                            $(e.target)
                                .parent()
                                .parent()
                                .find("p.description-no-hover")
                                .hide();
                            $(e.target)
                                .parent()
                                .parent()
                                .find("p.description")
                                .hide();
                            $(e.target)
                                .parent()
                                .parent()
                                .find("p.create-folder-description-placeholder")
                                .show();
                        }
                    };

                    $scope.handleDescriptionTitleBlur = function (e) {
                        var titleValue = $(e.target).val();
                        if(!titleValue.length){
                            titleValue = "Enter a description";
                        }
                        $(e.target).parent().find("div.folder-title").html(titleValue);
                        $(e.target).parent().find("div.folder-title-no-hover").html(titleValue);
                    };
                    $scope.hasFocusInCFDescription = false;
                    $scope.handleDescriptionTextareaFocus = function (e) {
                        logger("handleDescriptionTextareaFocus");
                        $(e.target)
                            .parent()
                            .parent()
                            .find("input.folder-title")
                            .hide();
                        $(e.target)
                            .parent()
                            .parent()
                            .find("div.folder-title-no-hover")
                            .hide();
                        $(e.target)
                            .parent()
                            .parent()
                            .find("div.folder-title")
                            .removeClass("ng-hide");
                        $(e.target)
                            .parent()
                            .parent()
                            .find("div.folder-title")
                            .show();

                        $scope.hasFocusInCFDescription = true;
                    };

                    $scope.handleDescriptionTextareaBlur = function (e) {
                        logger("handleDescriptionTextareaBlur");
                        var descriptionValue = $(e.target).val().trim();
                        $(e.target).parent().find("p.description").html(descriptionValue);
                        $(e.target).parent().find("p.description-no-hover").html(descriptionValue);
                        setTimeout(() => {
                            var cfDescriptionGrid =
                                $("textarea.create-folder-description-grid") &&
                                $("textarea.create-folder-description-grid")[0];
                            var cfDescriptionList =
                                $("textarea.create-folder-description-list") &&
                                $("textarea.create-folder-description-list")[0];

                            if (
                                document.activeElement !== cfDescriptionGrid &&
                                document.activeElement !== cfDescriptionList
                            ) {
                                $scope.hasFocusInCFDescription = false;
                            }
                        }, 500);
                    };

                    $scope.renderSource = null;

                    $scope.navbarClick = function (param) {
                        var clearForm = function () {
                            $("#zoom-event-title-form-field").val("");
                            $("#zoom-event-description-form-field").val("");
                            $(
                                "#zoomRecDestinationSelection li:first-child"
                            ).click();
                            $(".form-check.zoom-rec-type input").attr(
                                "checked",
                                false
                            );
                        };

                        if (param === "pnp") {
                            $scope.getParent();
                            clearForm();
                            return;
                        }

                        $scope.loadComponent(param);
                        clearForm();
                    };

                    $scope.handleBreadcrumbDownArrowClick = function(e) {
                        $scope.showCollectionTree = !$scope.showCollectionTree;


                        setTimeout(function(){
                            $('.collection-tree .search input').focus();
                        },100)
                    }

                    $scope.$watch('showCollectionTree', function() {
                        if($scope.showCollectionTree) {
                            var rootLeft =  parseInt($('.breadcrumb .root-container').width());
                            $('.collection-tree').css('left', rootLeft - 29);

                            $('.collection-tree .results').css('padding', '12px 8px');

                            setTimeout(() => {
                                $('.collection-tree .folder-image').html(imgFolderClosed);
                            }, 100)
                        }
                    });

                    $scope.checkSubfolderFromCurrentItem = function(term, node) {
                        var nodeList = node.children;

                        for(var i = 0; i < nodeList.length; i++) {
                            if(nodeList[i].title.toLowerCase().startsWith( term.toLowerCase() ) ) {
                                $scope.currentTitleContainsSearchTerm = true;
                            } else {
                                if(nodeList.children.length) {
                                    $scope.checkSubfolderFromCurrentItem(term, nodeList[i]);
                                }
                            }
                        }
                    }

                    //Using SVG in code as PD1 was not able to load these images from the assets/images folder
                    var imgFolderClosed = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                        '    <path d="M18 20H6C4.89688 20 4 19.1031 4 18V11H20V18C20 19.1031 19.1031 20 18 20ZM20 10H4V8C4 6.89688 4.89688 6 6 6H10C10.6281 6 11.2219 6.29687 11.6 6.8L12.2 7.6C12.3875 7.85312 12.6844 8 13 8H18C19.1031 8 20 8.89687 20 10Z" fill="#5884C7"/>' +
                        '</svg>';

                    var imgFolderOpened = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                        '    <path d="M5.77187 11.9938L3 16.7437V8C3 6.89688 3.89688 6 5 6H8.67188C9.20312 6 9.7125 6.20938 10.0875 6.58438L10.9156 7.4125C11.2906 7.7875 11.8 7.99688 12.3313 7.99688H16C17.1031 7.99688 18 8.89375 18 9.99687V10.9969H7.5C6.7875 10.9969 6.13125 11.375 5.77187 11.9906V11.9938ZM6.63438 12.4969C6.81563 12.1875 7.14375 12 7.5 12H20C20.3594 12 20.6875 12.1906 20.8656 12.5031C21.0438 12.8156 21.0437 13.1969 20.8625 13.5063L17.3625 19.5063C17.1844 19.8125 16.8562 20 16.5 20H4C3.64062 20 3.3125 19.8094 3.13438 19.4969C2.95625 19.1844 2.95625 18.8031 3.1375 18.4937L6.6375 12.4938L6.63438 12.4969Z" fill="#5884C7"/>' +
                        '</svg>';

                    $scope.handleCollectionTreeChevronClick = function(e, child) {
                        e.stopPropagation();

                        var decodedChild = $scope.decodedChild = child;

                        try {
                            decodedChild = $scope.decodedChild = JSON.parse(atob(child));
                        } catch(e) {
                        }

                        var clickedChevron = e.target;

                        //Folder is opened. Close it.
                        //If the image is already rotated, it means that the folder is opened
                        if($(clickedChevron).css('transform').indexOf('matrix') > -1) {
                            $(e.target).parents('.result-item').children('.folder-image').html(imgFolderClosed);
                            //Chevron to the right
                            $(clickedChevron).css('transform', '');

                            //Remove the subfolders
                            $(e.target).parents('.result-item').siblings('ul').remove();

                            return;

                        } else {
                            //Folder is closed. Open it.
                            $(e.target).parents('.result-item').children('.folder-image').html(imgFolderOpened);

                            //Chevron down
                            $(clickedChevron).css('transform', 'rotate(90deg)');
                        }

                        var currentMargin = $(e.target).parents('.result-item').children('.chevron-container').css('margin-left');
                        var indentation = parseInt(currentMargin.replace('px', '')) + 16;

                        var newElement = "<ul class='results'>";
                        var skipCurrentItem;

                        //Loop in decodedChild.children
                        for(var i = 0; i < decodedChild.children.length; i++) {
                            skipCurrentItem = false;

                            var term;
                            if($scope.collectionTreeSearchTerm && $scope.collectionTreeSearchTerm.length) {
                                term = $scope.collectionTreeSearchTerm.toLowerCase();
                            }
                            var currentTitle = decodedChild.children[i].title.toLowerCase();

                            if(term && $scope.collectionTreeSearchInProgress) {
                                if(!currentTitle.startsWith(term)) {
                                    skipCurrentItem = true;
                                }
                            }

                            if(!skipCurrentItem) {
                                newElement += "<li class='result-item' ng-click='openContent({type: \"Collection\", xid: \"" + decodedChild.children[i].cid + "\"})'>";

                                //If there are subfolders in the current item, add the chevron icon
                                if(decodedChild.children[i].children.length) {
                                    newElement += "<div style='margin-left: " + indentation + "px;' class='chevron-container' ng-click='handleCollectionTreeChevronClick($event, \"" + btoa(JSON.stringify(decodedChild.children[i])) + "\")'>";

                                    //If it's searching
                                    if($scope.collectionTreeSearchInProgress) {
                                        //if item or subfolder does match, add the chevron
                                        $scope.currentTitleContainsSearchTerm = false;
                                        $scope.checkSubfolderFromCurrentItem(term, decodedChild.children[i]);

                                        if($scope.currentTitleContainsSearchTerm) {
                                            newElement += "<img class='chevron' src='assets/images/chevron-right.svg'>";
                                        }
                                    } else {
                                        //It's not a search. Add chevron.
                                        newElement += "<img class='chevron' src='assets/images/chevron-right.svg'>";
                                    }
                                    newElement += "</div>";
                                } else {
                                    //Otherwise, add space to replace the chevron icon
                                    newElement += "<div style='width: " + parseInt(indentation + 20) + "px'></div>";
                                }

                                //Add folder closed icon and title
                                newElement += "<div class='folder-image'>" + imgFolderClosed + "</div>" +
                                    "<span class='title'>" + decodedChild.children[i].title + "</span>" +
                                    "</div>" +
                                    "</li>";
                            }

                        }

                        newElement += "</ul>";

                        var compiledElement = $compile(newElement)($scope);
                        angular.element($(e.target).parents('.result-item')[0]).after(compiledElement[0]);
                    }

                    $scope.handleBreadcrumbCollectionTreeKeyUp = function(e) {
                        if(e.target.value === '') {
                            //Show full tree
                            $scope.filteredCollectionTree = $scope.collectionTree;

                            setTimeout(function(){
                                $('.collection-tree .folder-image').html(imgFolderClosed);

                                //click on .result-item .chevron
                                $('.collection-tree .result-item .chevron').each(function(index, item) {
                                    if ($(item).css('transform').indexOf('matrix') > -1) {
                                        $(item).click();
                                    }
                                });
                            }, 100)
                        }
                    }

                    var foundList = [];
                    $scope.handleBreadcrumbCollectionTreeKeyPress = function(e) {
                        setTimeout(() => {
                            var term = $scope.collectionTreeSearchTerm = $(e.target).val();

                            //Create a copy of the tree to not affect the main collection tree.
                            var filteredTree = JSON.parse(JSON.stringify($scope.collectionTree));
                            var hasFoundTermInChildrenSearch;

                            function search(nodeList, term) {
                                for (let i = 0; i < nodeList.length; i++) {
                                    if (nodeList[i].title.toLowerCase().startsWith(term.toLowerCase())) {
                                        foundList.push(nodeList[i]);
                                    }

                                    search(nodeList[i].children, term);
                                }
                            }

                            function clearChildrenInFirstTreeMatch(nodeList, foundList) {
                                for (var i = 0; i < nodeList.length; i++) {
                                    for (var j = 0; j < foundList.length; j++) {
                                        if (JSON.stringify(foundList[j]) === JSON.stringify(nodeList[i])) {
                                            hasFoundTermInChildrenSearch = false;
                                            //look into nodeList.children for other matches in foundList
                                            clearChildrenInChildrenOfFirstTreeMatch(
                                                nodeList[i].children,
                                                foundList
                                            );

                                            if (!hasFoundTermInChildrenSearch) {
                                                nodeList[i].children = [];
                                            }
                                        } else {

                                        }
                                    }

                                    if (nodeList[i].children.length) {
                                        clearChildrenInFirstTreeMatch(nodeList[i].children, foundList);
                                    }
                                }
                            }

                            function clearChildrenInChildrenOfFirstTreeMatch(nodeList, foundList) {
                                for (var i = 0; i < nodeList.length; i++) {
                                    for (var j = 0; j < foundList.length; j++) {
                                        if (JSON.stringify(nodeList[i]) === JSON.stringify(foundList[j])) {
                                            hasFoundTermInChildrenSearch = true;
                                            //if found, do nothing with nodeList.children
                                        }
                                    }

                                    clearChildrenInChildrenOfFirstTreeMatch(
                                        nodeList[i].children,
                                        foundList
                                    );
                                }
                            }

                            var rootLevelHasResults;
                            function clearFirstLevelIfNoResultsInChildren(nodeList, foundList) {
                                for (var i = 0; i < nodeList.length; i++) {
                                    rootLevelHasResults = false;
                                    checkChildrenForTerm(nodeList[i].children, term);

                                    if(nodeList[i].title.toLowerCase().startsWith(term.toLowerCase())) {
                                        rootLevelHasResults = true;
                                    }

                                    if (!rootLevelHasResults) {
                                        nodeList.splice(i, 1);
                                        i--;
                                    }
                                }
                            }

                            function checkChildrenForTerm(nodeList, term) {
                                for(var i = 0; i < nodeList.length; i++) {
                                    if(nodeList[i].title.toLowerCase().startsWith(term.toLowerCase())) {
                                        rootLevelHasResults = true;
                                    }

                                    checkChildrenForTerm(nodeList[i].children, term);
                                }
                            }

                            function clickOnChevrons(params) {
                                var level = params.level;

                                if($(level).find('.chevron').length) {
                                    $(level).find('.chevron').each(function(index, item) {
                                        if(
                                            $(item).css('transform').indexOf('matrix') === -1 &&
                                            $(item).css('transform').indexOf('rotate') === -1
                                        ) {
                                            $(item).click();
                                        }
                                    });

                                    level = $(level).find('.results');
                                    setTimeout(function() {
                                        clickOnChevrons({level});
                                    }, 50)
                                }
                            }

                            $scope.collectionTreeSearchInProgress = true;
                            foundList = [];
                            search(filteredTree.children, term);

                            //Clear the children on search results
                            //If a search result contains another search result inside the children tree, clear only the last occurrence.
                            clearChildrenInFirstTreeMatch(filteredTree.children, foundList);

                            //Remove the first level of not found
                            //TODO: refactor to do the same in the search method.
                            clearFirstLevelIfNoResultsInChildren(filteredTree.children, foundList);

                            $scope.filteredCollectionTree = JSON.parse(JSON.stringify(filteredTree));

                            //Click on each closed chevrons to expand the menu with subfolders
                            setTimeout(function(){
                                var promise = new Promise(function(resolve) {
                                    clickOnChevrons({level: $('.breadcrumb .results')});
                                    resolve();
                                });

                                promise.then(function() {
                                    $scope.collectionTreeSearchInProgress = false;
                                });

                                setTimeout(function(){
                                    $('.breadcrumb .result-item.selected').removeClass('selected');
                                }, 2000);
                            }, 2000);
                        }, 0)
                    }

                    $scope.handleBreadcrumbRootContainerClick = function(cid) {
                        //if down arrow is visible
                        if($scope.filteredCollectionTree.children.length) {
                            if($scope.currentCollection.cid === $scope.rootLevelCollection.cid) {
                                $scope.showCollectionTree = !$scope.showCollectionTree;

                                setTimeout(function(){
                                    $('.collection-tree .search input').focus();
                                },100)
                            } else {
                                $scope.getParent(cid);
                            }
                        }
                        else {
                            $scope.showSearchResults = false;
                            $scope.activeView = 'grid';
                            //reload main content area of PnP
                            $scope.getParent($state.params.collectionId);
                        }
                    }

                    $scope.handleBreadcrumbEllipsisClick = function(e) {
                        $(e.target).parents('.breadcrumb').find('.breadcrumb-menu').toggle();

                        setTimeout(function(){
                            if($(e.target).parents('.breadcrumb').find('.breadcrumb-menu').is(':visible')) {
                                var intervalId = setInterval(function(){
                                    if($('.breadcrumb-menu li:nth-child(1) > div > span')[0].offsetWidth) {
                                        clearInterval(intervalId);

                                        //check each LI if there's ellipsis
                                        for(var i = 0; i < $('.breadcrumb-menu li').length; i++) {
                                            if(hasEllipsisWidth($('.breadcrumb-menu li:nth-child(' + (i + 1) + ') > div > span')[0])) {
                                                $scope.crumbsForMenu[i].hasEllipsis = true;
                                            } else {
                                                $scope.crumbsForMenu[i].hasEllipsis = false;
                                            }
                                        }
                                    }
                                }, 100);
                                $(e.target).parents('.breadcrumb').find('.breadcrumb-menu').find('[tabindex="0"]').first().focus();
                                $(e.target).parents('.breadcrumb').find(".ellipsis").first().attr("aria-expanded",true);
                            }else{
                                $(e.target).parents('.breadcrumb').find(".ellipsis").first().attr("aria-expanded",false);
                            }
                        }, 100)
                    }

                    $scope.handleBreadcrumbMenuItemClick = function(e, cid) {
                        $scope.openContent({type: 'Collection', xid: cid});
                        $(e.target).parents('.breadcrumb').find('.breadcrumb-menu').hide();
                    }

                    $scope.getRootBreadcrumbIcon = function() {
                        var path = 'assets/images/root-breadcrumb-';

                        if($scope.rootCollectionType) {
                            switch ($scope.rootCollectionType.toLowerCase()) {
                                case 'course':
                                    path += 'course.svg';
                                    break;
                                case 'protected':
                                    path += 'collection.svg';
                                    break;
                                case 'channel':
                                    path += 'channel.svg';
                                    break;
                            }
                        }

                        return path;
                    }

                    $scope.handleBreadcrumbOverflowListItemContainerMouseOver = function(e) {
                        logger('handleBreadcrumbOverflowListItemContainerMouseOver');
                        $(e.target).css('background', '#F2F3F5');
                        $(e.target).find('span').css('background', '#F2F3F5');
                    }

                    $scope.handleBreadcrumbOverflowListItemContainerSpanMouseOver = function(e) {
                        logger('handleBreadcrumbOverflowListItemContainerMouseOver');
                        $(e.target).css('background', '#F2F3F5');
                        $(e.target).parent().css('background', '#F2F3F5');
                    }

                    $scope.handleBreadcrumbOverflowListItemContainerMouseOut = function(e) {
                        logger('handleBreadcrumbOverflowListItemContainerMouseOut');
                        $(e.target).css('background', '#FFFFFF');
                        $(e.target).find('span').css('background', '#FFFFFF');
                    }

                    $scope.handleBreadcrumbOverflowListItemContainerSpanMouseOut = function(e) {
                        logger('handleBreadcrumbOverflowListItemContainerMouseOut');
                        $(e.target).css('background', '#FFFFFF');
                        $(e.target).parent().css('background', '#FFFFFF');
                    }

                    $scope.handleBreadcrumbOverflowLIMouseOver = function(e) {
                        //if last,
                        //control padding top
                        // e.stopPropagation();
                        // var element = null;
                        // var isLastElement = true;
                        //
                        // //get the LI element
                        // if(e.target.nodeName === 'DIV' || e.target.nodeName === 'SPAN') {
                        //     element = $(e.target).parents('li');
                        // }
                        //
                        // if(e.target.nodeName === 'LI') {
                        //     element = $(e.target);
                        // }
                        //
                        // //check the next element.
                        // //It can be a DIV, related to the tooltip
                        // if( $(element).next().length ) {
                        //     element = $(element).next();
                        //
                        //     if($(element)[0].nodeName === 'DIV') {
                        //         if($(element).next().length) {
                        //             element = $(element).next();
                        //
                        //             if($(element)[0].nodeName === 'LI') {
                        //                 isLastElement = false;
                        //             }
                        //         }
                        //     } else {
                        //         if($(element)[0].nodeName === 'LI') {
                        //             isLastElement = false;
                        //         }
                        //     }
                        // } else {
                        //     isLastElement = true;
                        // }
                        //
                        // console.log('isLastElement', isLastElement)
                        //
                        // if(isLastElement) {
                        //     // $(element).css('padding-top', '0')
                        //
                        //     console.log('last child length', $('.breadcrumb-menu li:last-child').length )
                        // }
                    }

                    $scope.handleBreadcrumbOverflowLIMouseOut = function(e) {
                        //if last,
                        //undo padding top
                    }

                    $(window).on("click.collectioncontroller", function (e) {
                        logger("window click");
                        $scope.hideMenuWhenClickOutside(e);
                        $scope.hideBreadcrumbMenuWhenClickOutside(e);
                        $scope.persistCreateFolderContent(e);
                        $scope.hideBreadcrumbTreeViewWhenClickOutside(e);
                        $scope.hideUploadMenuWhenClickOutside(e);
                    });

                    $(document).on("keydown.collectioncontroller",function (e) {
                        logger("body keydown");
                        if (e.which === 27) {
                            $(".menu").hide();
                            //set menu icon aria-expanded to false
                            $(".menu-icon").attr("aria-expanded","false");
                            $(".dropdown-toggle").removeClass("open").attr("aria-expanded","false");
                            $scope.showCollectionTree = false;
                            $scope.$apply();
                            if($(".breadcrumb-menu").is(":visible")){
                                $(".breadcrumb-menu:visible").parents('.breadcrumb').find('.ellipsis').first().focus();
                                $(".breadcrumb-menu:visible").parents('.breadcrumb').find(".ellipsis").first().attr("aria-expanded",false);
                                $('.breadcrumb-menu').hide();
                            }
                            $('.tooltip').hide();
                        }
                    });

                    $scope.$on('$destroy', function() {
                        console.log('collction.controller.js controller is being destroyed, performing cleanup...');
                        $(document).off("keydown.collectioncontroller");
                        $(window).off("click.collectioncontroller");
                    });
                }
            });
        }
    );
